/**
 * Nepali translations, keyed by the English text used in the code.
 * Missing keys fall back to English.
 */
export const ne: Record<string, string> = {
  // Shell
  Main: 'मुख्य',
  Platform: 'प्लेटफर्म',
  Overview: 'सारांश',
  Network: 'नेटवर्क',
  'Charging & money': 'चार्जिङ र पैसा',
  Customers: 'ग्राहकहरू',
  Operations: 'सञ्चालन',
  Reports: 'रिपोर्ट',
  Organization: 'संस्था',
  Dashboard: 'ड्यासबोर्ड',
  'Live operations': 'लाइभ सञ्चालन',
  Stations: 'स्टेसनहरू',
  Chargers: 'चार्जरहरू',
  Reservations: 'आरक्षण',
  'Load management': 'लोड व्यवस्थापन',
  Sessions: 'सत्रहरू',
  Anomalies: 'असामान्य सत्र',
  'Pricing plans': 'मूल्य योजना',
  'Online top-ups': 'अनलाइन रिचार्ज',
  Promotions: 'प्रमोसन',
  'RFID cards': 'RFID कार्ड',
  'Wallet transactions': 'वालेट कारोबार',
  Maintenance: 'मर्मत',
  Alerts: 'सतर्कता',
  'Charger logs': 'चार्जर लग',
  'Revenue & energy': 'आम्दानी र ऊर्जा',
  Uptime: 'चालु समय',
  'NEA electricity': 'नेविप्रा बिजुली',
  Settlements: 'हिसाब मिलान',
  'Team & access': 'टोली र पहुँच',
  Settings: 'सेटिङ',
  'Audit log': 'अडिट लग',
  'Platform overview': 'प्लेटफर्म सारांश',
  Operators: 'सञ्चालकहरू',
  Users: 'प्रयोगकर्ताहरू',
  'All chargers': 'सबै चार्जर',
  'All sessions': 'सबै सत्र',
  'Super Cards': 'सुपर कार्ड',
  Transactions: 'कारोबार',
  'Push notifications': 'पुस सूचना',
  'App carousel': 'एप क्यारोसेल',
  'Platform settings': 'प्लेटफर्म सेटिङ',
  Live: 'लाइभ',
  'Connecting…': 'जोडिँदै…',
  Offline: 'अफलाइन',
  'Live updates from chargers': 'चार्जरबाट लाइभ अपडेट',
  'Choose an operator': 'सञ्चालक छान्नुहोस्',
  'View the dashboard as': 'यस रूपमा ड्यासबोर्ड हेर्नुहोस्',
  Viewing: 'हेर्दै',
  'Stop viewing an operator': 'सञ्चालक हेर्न बन्द गर्नुहोस्',
  'Light mode': 'उज्यालो मोड',
  'Dark mode': 'अँध्यारो मोड',
  Account: 'खाता',
  'My profile': 'मेरो प्रोफाइल',
  'Sign out': 'बाहिर निस्कनुहोस्',
  'Open menu': 'मेनु खोल्नुहोस्',
  'Close menu': 'मेनु बन्द गर्नुहोस्',
  'Waiting for backend': 'ब्याकइन्डको पर्खाइमा',
  'Waiting for backend · {code}': 'ब्याकइन्डको पर्खाइमा · {code}',
  // Roles
  Superadmin: 'सुपरएडमिन',
  'Operator admin': 'सञ्चालक एडमिन',
  'Station manager': 'स्टेसन म्यानेजर',
  'Station operator': 'स्टेसन अपरेटर',
  Viewer: 'भ्युअर',
  Driver: 'चालक',
  // Login
  'Sign in to your network': 'आफ्नो नेटवर्कमा साइन इन गर्नुहोस्',
  'For charge point operators, station staff and the Saadhan Charge team.': 'चार्जिङ स्टेसन सञ्चालक, स्टेसन कर्मचारी र साधन चार्ज टोलीका लागि।',
  'Phone or email': 'फोन वा इमेल',
  Password: 'पासवर्ड',
  'Show password': 'पासवर्ड देखाउनुहोस्',
  'Hide password': 'पासवर्ड लुकाउनुहोस्',
  'Sign in': 'साइन इन',
  'Forgot your password? Ask your operator admin, or write to': 'पासवर्ड बिर्सनुभयो? आफ्नो सञ्चालक एडमिनलाई सोध्नुहोस्, वा लेख्नुहोस्',
  'Charging station management': 'चार्जिङ स्टेसन व्यवस्थापन',
  'Every charger, session and rupee, live.': 'हरेक चार्जर, सत्र र रुपैयाँ, लाइभ।',
  'Stations, chargers, pricing, customers, cards, payouts and NEA bills, on any OCPP 1.6J charger.': 'स्टेसन, चार्जर, मूल्य, ग्राहक, कार्ड, भुक्तानी र नेविप्रा बिल, जुनसुकै OCPP 1.6J चार्जरमा।',
  'This dashboard is for charge point operators and their staff. Drivers can use the Saadhan Charge app.': 'यो ड्यासबोर्ड चार्जिङ स्टेसन सञ्चालक र तिनका कर्मचारीका लागि हो। चालकले साधन चार्ज एप प्रयोग गर्न सक्छन्।',
  // Guards and states
  'Choose an operator to view': 'हेर्न सञ्चालक छान्नुहोस्',
  "Operator screens show one operator's network. Pick one with the switcher at the top, or go to the platform overview.": 'सञ्चालक स्क्रिनले एउटा सञ्चालकको नेटवर्क देखाउँछ। माथिको स्विचरबाट छान्नुहोस्, वा प्लेटफर्म सारांशमा जानुहोस्।',
  "You don't have access to this page": 'तपाईंलाई यो पेजमा पहुँच छैन',
  'Ask your operator admin if you need it.': 'चाहिएमा आफ्नो सञ्चालक एडमिनलाई सोध्नुहोस्।',
  "Couldn't load this": 'यो लोड गर्न सकिएन',
  'Try again': 'फेरि प्रयास गर्नुहोस्',
  Cancel: 'रद्द गर्नुहोस्',
  Save: 'सेभ गर्नुहोस्',
  Close: 'बन्द गर्नुहोस्',
  Delete: 'मेटाउनुहोस्',
  Edit: 'सम्पादन',
  Add: 'थप्नुहोस्',
  Search: 'खोज्नुहोस्',
  Refresh: 'ताजा गर्नुहोस्',
  Export: 'निर्यात',
  All: 'सबै',
  Status: 'स्थिति',
  Actions: 'कार्यहरू',
  Name: 'नाम',
  Phone: 'फोन',
  Email: 'इमेल',
  Station: 'स्टेसन',
  Charger: 'चार्जर',
  Connector: 'कनेक्टर',
  Customer: 'ग्राहक',
  Energy: 'ऊर्जा',
  Cost: 'शुल्क',
  Revenue: 'आम्दानी',
  Power: 'पावर',
  Started: 'सुरु',
  'Transaction ID': 'कारोबार आईडी',
  Duration: 'अवधि',
  Today: 'आज',
  Yesterday: 'हिजो',
  '{n} results': '{n} नतिजा',
  'Page {page} of {total}': 'पेज {page} / {total}',
  'Previous page': 'अघिल्लो पेज',
  'Next page': 'अर्को पेज',
  // Status labels
  Available: 'उपलब्ध',
  'Plugged in': 'प्लग गरिएको',
  Charging: 'चार्ज हुँदै',
  'Paused by car': 'गाडीले रोकेको',
  'Paused by charger': 'चार्जरले रोकेको',
  Finishing: 'सकिँदै',
  Reserved: 'आरक्षित',
  Unavailable: 'अनुपलब्ध',
  Faulted: 'खराबी',
  Online: 'अनलाइन',
  Completed: 'सम्पन्न',
  Interrupted: 'अवरुद्ध',
  Stopped: 'रोकिएको',
  Failed: 'असफल',

  // Screens
  ' for {n} min': ' {n} मिनेटका लागि',
  '% on top': 'माथि %',
  'A link the charger can download from, given by the manufacturer.': 'निर्माताले दिएको, चार्जरले डाउनलोड गर्न सक्ने लिङ्क।',
  'A person can work at one station at a time. Giving access again moves them.': 'एक व्यक्तिले एक पटकमा एउटै स्टेसनमा काम गर्न सक्छ। फेरि पहुँच दिँदा उहाँ सरिनुहुन्छ।',
  'Accept payments': 'भुक्तानी लिनुहोस्',
  'Access removed': 'पहुँच हटाइयो',
  'Account active': 'खाता सक्रिय',
  'Account deleted': 'खाता मेटाइयो',
  'Activate': 'सक्रिय गर्नुहोस्',
  'Active': 'सक्रिय',
  'Active on this page': 'यो पृष्ठमा सक्रिय',
  'Add Saadhan wallet credit': 'साधन वालेटमा रकम थप्नुहोस्',
  'Add a charger': 'चार्जर थप्नुहोस्',
  'Add a charger to a station and point it at Saadhan Charge; it appears here when it connects.': 'स्टेसनमा चार्जर थपेर साधन चार्जमा जोड्नुहोस्; जोडिएपछि यहाँ देखिन्छ।',
  'Add a charger, then set its OCPP server address to Saadhan Charge.': 'चार्जर थप्नुहोस्, अनि यसको OCPP सर्भर ठेगाना साधन चार्ज राख्नुहोस्।',
  'Add a note': 'टिप्पणी थप्नुहोस्',
  'Add a station': 'स्टेसन थप्नुहोस्',
  'Add a time window': 'समय अवधि थप्नुहोस्',
  'Add charger': 'चार्जर थप्नुहोस्',
  'Add connector': 'कनेक्टर थप्नुहोस्',
  'Add contact': 'सम्पर्क थप्नुहोस्',
  'Add credit': 'रकम थप्नुहोस्',
  'Add meter': 'मिटर थप्नुहोस्',
  'Add operator': 'सञ्चालक थप्नुहोस्',
  'Add part': 'भाग थप्नुहोस्',
  'Add slide': 'स्लाइड थप्नुहोस्',
  'Add slot': 'समय थप्नुहोस्',
  'Add station': 'स्टेसन थप्नुहोस्',
  'Add the station\'s NEA office, SC number and consumer ID, exactly as printed on the bill.': 'बिलमा छापिएजस्तै स्टेसनको NEA कार्यालय, SC नम्बर र ग्राहक ID थप्नुहोस्।',
  'Add your first station, then add its chargers.': 'पहिलो स्टेसन थप्नुहोस्, अनि त्यसका चार्जरहरू थप्नुहोस्।',
  'Added': 'थपिएको',
  'Added (this page)': 'थपिएको (यो पृष्ठ)',
  'Address': 'ठेगाना',
  'Adjusted at the end': 'अन्त्यमा मिलाइयो',
  'After it ends, use': 'सकिएपछि प्रयोग गर्ने',
  'Alert rule deleted': 'सतर्कता नियम मेटाइयो',
  'Alert rule saved': 'सतर्कता नियम सुरक्षित भयो',
  'All bills': 'सबै बिल',
  'All levels': 'सबै तह',
  'All logs': 'सबै लग',
  'All operators': 'सबै सञ्चालक',
  'All stations': 'सबै स्टेसन',
  'All tickets': 'सबै टिकट',
  'All types': 'सबै प्रकार',
  'Amenities': 'सुविधाहरू',
  'Amount': 'रकम',
  'Amount (Rs.)': 'रकम (रू.)',
  'Anomaly: {type}': 'असामान्य: {type}',
  'Any status': 'कुनै पनि अवस्था',
  'App': 'एप',
  'App home slides': 'एपका गृह स्लाइड',
  'App notification': 'एप सूचना',
  'Appearance': 'रूप',
  'Ask the charger to report': 'चार्जरलाई जानकारी पठाउन भन्नुहोस्',
  'Assigned to': 'जिम्मा',
  'At least 8 characters.': 'कम्तीमा ८ अक्षर।',
  'At least 8 characters. Ask them to change it after signing in.': 'कम्तीमा ८ अक्षर। साइन इन गरेपछि परिवर्तन गर्न भन्नुहोस्।',
  'Average per session': 'प्रति सत्र औसत',
  'Average top-up': 'औसत रिचार्ज',
  'Balance after': 'पछिको मौज्दात',
  'Battery': 'ब्याट्री',
  'Battery {soc}': 'ब्याट्री {soc}',
  'Below 95%': '९५% भन्दा कम',
  'Bill period': 'बिल अवधि',
  'Bill requested from NEA. It usually arrives within a few minutes.': 'NEA बाट बिल माग गरियो। प्रायः केही मिनेटमै आउँछ।',
  'Bills': 'बिलहरू',
  'Bills fetched': 'ल्याइएका बिल',
  'Block (lost or stolen)': 'रोक्नुहोस् (हराएको वा चोरी)',
  'Blocked': 'रोकिएको',
  'Blocked on this page': 'यो पृष्ठमा रोकिएको',
  'Brand name': 'ब्रान्ड नाम',
  'By charger': 'चार्जर अनुसार',
  'By connector': 'कनेक्टर अनुसार',
  'By station': 'स्टेसन अनुसार',
  'Cache cleared': 'क्यास खाली गरियो',
  'Caption': 'क्याप्सन',
  'Card': 'कार्ड',
  'Card actions': 'कार्ड कार्यहरू',
  'Card issued': 'कार्ड जारी भयो',
  'Card number': 'कार्ड नम्बर',
  'Card number or customer': 'कार्ड नम्बर वा ग्राहक',
  'Card removed': 'कार्ड हटाइयो',
  'Card updated': 'कार्ड अद्यावधिक भयो',
  'Cards': 'कार्डहरू',
  'Cards drivers tap on the charger to start. Block a card straight away if it is lost.': 'चालकहरूले चार्ज सुरु गर्न चार्जरमा छुवाउने कार्ड। हराएमा तुरुन्तै रोक्नुहोस्।',
  'Change': 'परिवर्तन',
  'Change image': 'तस्बिर बदल्नुहोस्',
  'Change password': 'पासवर्ड बदल्नुहोस्',
  'Change picture': 'तस्बिर बदल्नुहोस्',
  'Change role or station': 'भूमिका वा स्टेसन बदल्नुहोस्',
  'Changes': 'परिवर्तनहरू',
  'Charge Point ID': 'चार्ज पोइन्ट ID',
  'Charged while charging': 'चार्ज हुँदै गर्दा लागेको',
  'Charger ID': 'चार्जर ID',
  'Charger ID (Charge Point ID)': 'चार्जर ID (चार्ज पोइन्ट ID)',
  'Charger actions': 'चार्जर कार्यहरू',
  'Charger added. Set its OCPP server address to Saadhan Charge and it will connect.': 'चार्जर थपियो। यसको OCPP सर्भर ठेगाना साधन चार्ज राखेपछि जोडिन्छ।',
  'Charger answered: {status}': 'चार्जरको जवाफ: {status}',
  'Charger asked to send {m}': 'चार्जरलाई {m} पठाउन भनियो',
  'Charger configuration': 'चार्जर कन्फिगरेसन',
  'Charger deleted': 'चार्जर मेटाइयो',
  'Charger log': 'चार्जर लग',
  'Charger offline 15 min': 'चार्जर १५ मिनेट अफलाइन',
  'Charger password': 'चार्जर पासवर्ड',
  'Charger saved': 'चार्जर सुरक्षित भयो',
  'Chargers connect with their ID only today, and the ID is printed on the charger. Per-charger passwords need B2 in the backend requests; it is the most important security fix.': 'अहिले चार्जरहरू आफ्नो ID मात्रले जोडिन्छन्, र ID चार्जरमै छापिएको हुन्छ। प्रति-चार्जर पासवर्डका लागि ब्याकएन्ड अनुरोधमा B2 चाहिन्छ; यो सबैभन्दा महत्त्वपूर्ण सुरक्षा सुधार हो।',
  'Chargers must support the OCPP Smart Charging profile; most DC chargers do.': 'चार्जरले OCPP स्मार्ट चार्जिङ प्रोफाइल समर्थन गर्नुपर्छ; धेरैजसो DC चार्जरले गर्छन्।',
  'Chargers online': 'अनलाइन चार्जर',
  'Charges': 'शुल्कहरू',
  'Charges paid with a Saadhan super card at your stations. Saadhan Charge pays these amounts to you.': 'तपाईंका स्टेसनमा साधन सुपर कार्डले तिरिएका शुल्क। यो रकम साधन चार्जले तपाईंलाई तिर्छ।',
  'Charges paid with super cards': 'सुपर कार्डले तिरिएका शुल्क',
  'Charging at {station}': '{station} मा चार्ज हुँदै',
  'Charging now': 'अहिले चार्ज हुँदै',
  'Charging sessions across every operator.': 'सबै सञ्चालकका चार्जिङ सत्रहरू।',
  'Choose': 'छान्नुहोस्',
  'Choose a card': 'कार्ड छान्नुहोस्',
  'Could not load your cards.': 'तपाईंका कार्डहरू लोड गर्न सकिएन।',
  'Your cards are blocked, inactive or expired.': 'तपाईंका कार्डहरू ब्लक, निष्क्रिय वा म्याद सकिएका छन्।',
  'No card is linked to your account.': 'तपाईंको खातामा कुनै कार्ड जोडिएको छैन।',
  'Ask the station owner to issue you a card, then try again.': 'स्टेसन मालिकलाई कार्ड जारी गर्न भन्नुहोस्, अनि फेरि प्रयास गर्नुहोस्।',
  'Super card': 'सुपर कार्ड',
  'Choose a station': 'स्टेसन छान्नुहोस्',
  'Choose an operator to export': 'निर्यात गर्न सञ्चालक छान्नुहोस्',
  'Choose connectors': 'कनेक्टर छान्नुहोस्',
  'Choose image': 'तस्बिर छान्नुहोस्',
  'Clear cache': 'क्यास खाली गर्नुहोस्',
  'Clear card cache': 'कार्ड क्यास खाली गर्नुहोस्',
  'Clear the card cache on {id}?': '{id} को कार्ड क्यास खाली गर्ने?',
  'Click the map to place the station, then drag the pin to adjust.': 'स्टेसन राख्न नक्सामा क्लिक गर्नुहोस्, अनि मिलाउन पिन तान्नुहोस्।',
  'Closed': 'बन्द',
  'Closes': 'बन्द हुने',
  'Code': 'कोड',
  'Codes like DASHAIN10 that drivers enter in the app: a percentage or amount off, or free kWh, limited by dates, number of uses and stations. The discount is applied when the session is settled. This needs B11 in the backend requests.': 'DASHAIN10 जस्ता कोड जुन चालकले एपमा हाल्छन्: प्रतिशत वा रकम छुट, वा निःशुल्क kWh, मिति, प्रयोग संख्या र स्टेसनले सीमित। सत्र टुङ्गिँदा छुट लागू हुन्छ। यसका लागि ब्याकएन्ड अनुरोधमा B11 चाहिन्छ।',
  'Companies running charging stations on Saadhan Charge.': 'साधन चार्जमा चार्जिङ स्टेसन चलाउने कम्पनीहरू।',
  'Company details': 'कम्पनी विवरण',
  'Company name': 'कम्पनीको नाम',
  'Configuration': 'कन्फिगरेसन',
  'Connect the charger': 'चार्जर जोड्नुहोस्',
  'Connection & security': 'जडान र सुरक्षा',
  'Connections, faults, boots and commands from every charger, newest first.': 'सबै चार्जरका जडान, खराबी, बुट र आदेशहरू, नयाँ पहिले।',
  'Connector reserved': 'कनेक्टर आरक्षित भयो',
  'Connector status': 'कनेक्टर अवस्था',
  'Connector updated': 'कनेक्टर अद्यावधिक भयो',
  'Connector {n}': 'कनेक्टर {n}',
  'Connectors': 'कनेक्टरहरू',
  'Connectors charging': 'चार्ज हुँदै गरेका कनेक्टर',
  'Connectors on this plan go back to the default plan. Past sessions keep the price they were charged.': 'यो योजनाका कनेक्टरहरू पूर्वनिर्धारित योजनामा फर्कन्छन्। पुराना सत्रको मूल्य उस्तै रहन्छ।',
  'Connectors on {name}': '{name} मा रहेका कनेक्टर',
  'Connectors updated': 'कनेक्टरहरू अद्यावधिक भए',
  'Consumer ID': 'ग्राहक ID',
  'Contacts': 'सम्पर्कहरू',
  'Copied': 'प्रतिलिपि भयो',
  'Copy': 'प्रतिलिपि',
  'Copy it now; it will not be shown again.': 'अहिले नै प्रतिलिपि गर्नुहोस्; फेरि देखाइने छैन।',
  'Correct status': 'अवस्था सच्याउनुहोस्',
  'Correct the session status': 'सत्रको अवस्था सच्याउनुहोस्',
  'Create': 'बनाउनुहोस्',
  'Create a new charger password?': 'नयाँ चार्जर पासवर्ड बनाउने?',
  'Create a plan so drivers know what they pay.': 'चालकले कति तिर्छन् थाहा पाउन योजना बनाउनुहोस्।',
  'Create password': 'पासवर्ड बनाउनुहोस्',
  'Created': 'बनाइएको',
  'Creates the company and the owner account that signs in to this dashboard.': 'कम्पनी र यो ड्यासबोर्डमा साइन इन गर्ने मालिकको खाता बनाउँछ।',
  'Credit added at the counter, charging payments and refunds.': 'काउन्टरमा थपिएको रकम, चार्जिङ भुक्तानी र फिर्ता।',
  'Critical': 'गम्भीर',
  'Current': 'करेन्ट',
  'Current password': 'हालको पासवर्ड',
  'Customer not found': 'ग्राहक भेटिएन',
  'Custom…': 'आफैं छान्नुहोस्…',
  'Dark': 'गाढा',
  'Deactivate': 'निष्क्रिय गर्नुहोस्',
  'Deduct': 'कटाउनुहोस्',
  'Deduct Saadhan wallet credit': 'साधन वालेटबाट रकम कटाउनुहोस्',
  'Deduct credit': 'रकम कटाउनुहोस्',
  'Deducted': 'कटाइएको',
  'Default': 'पूर्वनिर्धारित',
  'Default plan': 'पूर्वनिर्धारित योजना',
  'Default plan changed': 'पूर्वनिर्धारित योजना बदलियो',
  'Delete account': 'खाता मेटाउनुहोस्',
  'Delete charger': 'चार्जर मेटाउनुहोस्',
  'Delete slide': 'स्लाइड मेटाउनुहोस्',
  'Delete station': 'स्टेसन मेटाउनुहोस्',
  'Delete this slide?': 'यो स्लाइड मेटाउने?',
  'Delete {id}?': '{id} मेटाउने?',
  'Delete {name}?': '{name} मेटाउने?',
  'Description': 'विवरण',
  'Description (shown to drivers)': 'विवरण (चालकलाई देखिने)',
  'Details': 'विवरण',
  'Diagnostics': 'डायग्नोस्टिक्स',
  'Diagnostics requested. The file appears here when the charger uploads it.': 'डायग्नोस्टिक्स माग गरियो। चार्जरले अपलोड गरेपछि फाइल यहाँ देखिन्छ।',
  'Difference': 'फरक',
  'Directions or anything drivers should know.': 'बाटो वा चालकले थाहा पाउनुपर्ने कुरा।',
  'Discount': 'छुट',
  'Discount codes for festivals, launches and fleet partners, applied automatically at the end of a charge.': 'चाडपर्व, सुरुवात र फ्लीट साझेदारका लागि छुट कोड, चार्ज सकिँदा आफैं लागू हुने।',
  'Download': 'डाउनलोड',
  'Download as a spreadsheet': 'स्प्रेडसिटको रूपमा डाउनलोड',
  'Download started': 'डाउनलोड सुरु भयो',
  'Drawing now': 'अहिले लिइरहेको',
  'Driver pays': 'चालकले तिर्ने',
  'Drivers': 'चालकहरू',
  'Drivers can charge on it again.': 'चालकहरूले फेरि यसमा चार्ज गर्न सक्छन्।',
  'Drivers top up their wallet in the app with eSewa, Khalti or Fonepay, any time, without visiting the counter.': 'चालकहरूले काउन्टर नआई जुनसुकै बेला एपमा eSewa, Khalti वा Fonepay बाट वालेट रिचार्ज गर्छन्।',
  'Drivers who charge on your network, their wallet balance with you and their cards.': 'तपाईंको नेटवर्कमा चार्ज गर्ने चालकहरू, तपाईंसँगको वालेट मौज्दात र कार्डहरू।',
  'Drivers will see it as unavailable and no one can start a charge on it.': 'चालकहरूले यसलाई अनुपलब्ध देख्छन् र कसैले चार्ज सुरु गर्न सक्दैन।',
  'Due': 'तिर्नुपर्ने मिति',
  'Each slot must end after it starts.': 'हरेक समय सुरु भएपछि मात्र सकिनुपर्छ।',
  'Edit alert': 'सतर्कता सम्पादन',
  'Edit meter': 'मिटर सम्पादन',
  'Edit slide': 'स्लाइड सम्पादन',
  'Edit {id}': '{id} सम्पादन',
  'Edit {name}': '{name} सम्पादन',
  'Electricity cost (Rs. per kWh)': 'बिजुली लागत (रू. प्रति kWh)',
  'Electricity costs used by dynamic price plans, and charger timing.': 'गतिशील मूल्य योजनाले प्रयोग गर्ने बिजुली लागत, र चार्जरको समय।',
  'Empty for unlimited': 'असीमितका लागि खाली',
  'Ended': 'सकियो',
  'Ends': 'सकिने',
  'Energy (this page)': 'ऊर्जा (यो पृष्ठ)',
  'Energy delivered': 'दिइएको ऊर्जा',
  'Energy on this page': 'यो पृष्ठको ऊर्जा',
  'Energy, 30 days': 'ऊर्जा, ३० दिन',
  'Enter the price per kWh.': 'प्रति kWh मूल्य हाल्नुहोस्।',
  'Enter these in the charger\'s OCPP settings (or ask the installer).': 'यी चार्जरको OCPP सेटिङमा हाल्नुहोस् (वा जडानकर्तालाई भन्नुहोस्)।',
  'Equally between cars': 'गाडीहरूबीच बराबर',
  'Error': 'त्रुटि',
  'Event': 'घटना',
  'Every account on the platform: drivers, operator owners and station staff.': 'प्लेटफर्मका सबै खाता: चालक, सञ्चालक मालिक र स्टेसन कर्मचारी।',
  'Every change made through the dashboard or the API (price changes, credit added, cards blocked, charger resets, staff given access) recorded with who did it, when, from where and what changed. This needs B9 in the backend requests.': 'ड्यासबोर्ड वा API बाट गरिएका सबै परिवर्तन (मूल्य परिवर्तन, थपिएको रकम, रोकिएका कार्ड, चार्जर रिसेट, कर्मचारीलाई दिइएको पहुँच) कसले, कहिले, कहाँबाट र के बदल्यो सहित रेकर्ड। यसका लागि ब्याकएन्ड अनुरोधमा B9 चाहिन्छ।',
  'Every charge on your network. Click one for the meter readings, price breakdown and corrections.': 'तपाईंको नेटवर्कका सबै चार्ज। मिटर रिडिङ, मूल्य विवरण र सच्याउन कुनै एकमा क्लिक गर्नुहोस्।',
  'Every charger is online': 'सबै चार्जर अनलाइन छन्',
  'Every charger on the platform, across operators.': 'सबै सञ्चालकका, प्लेटफर्मका सबै चार्जर।',
  'Every charger on your network, its connectors and when it last checked in.': 'तपाईंको नेटवर्कका सबै चार्जर, तिनका कनेक्टर र अन्तिम पटक जोडिएको समय।',
  'Every connector on your network, as the chargers report it.': 'चार्जरले जनाएअनुसार तपाईंको नेटवर्कका सबै कनेक्टर।',
  'Every fault a charger reports, and every charger offline longer than you allow, opens a ticket with the right priority. Staff can comment, assign and close tickets, and you see repair times per charger. This needs B4 in the backend requests.': 'चार्जरले जनाएको हरेक खराबी, र तपाईंले तोकेभन्दा लामो समय अफलाइन रहेको हरेक चार्जरले उपयुक्त प्राथमिकतासहित टिकट खोल्छ। कर्मचारीले टिप्पणी, जिम्मा र टिकट बन्द गर्न सक्छन्, र तपाईंले प्रति चार्जर मर्मत समय देख्नुहुन्छ। यसका लागि ब्याकएन्ड अनुरोधमा B4 चाहिन्छ।',
  'Every operator on Saadhan Charge.': 'साधन चार्जका सबै सञ्चालक।',
  'Every part needs a name and a value above zero.': 'हरेक भागमा नाम र शून्यभन्दा बढी मान चाहिन्छ।',
  'Every session in this period adds up.': 'यो अवधिका सबै सत्र मिल्छन्।',
  'Every slot needs a price.': 'हरेक समयमा मूल्य चाहिन्छ।',
  'Everyone': 'सबैजना',
  'Everyone with a role': 'भूमिका भएका सबैजना',
  'Everything here appears in the driver app as soon as you save.': 'सुरक्षित गर्नेबित्तिकै यहाँका सबै कुरा चालकको एपमा देखिन्छन्।',
  'Everything, at every station: money, prices, customers, team.': 'हरेक स्टेसनमा सबै कुरा: पैसा, मूल्य, ग्राहक, टोली।',
  'Exactly as printed on the NEA bill.': 'NEA बिलमा छापिएजस्तै।',
  'Expired': 'म्याद सकिएको',
  'Expires': 'म्याद सकिने',
  'Expires (optional)': 'म्याद सकिने (ऐच्छिक)',
  'Faults': 'खराबीहरू',
  'Faults and offline chargers become tickets automatically; assign them, track repairs and keep a history per charger.': 'खराबी र अफलाइन चार्जर आफैं टिकट बन्छन्; जिम्मा दिनुहोस्, मर्मत ट्र्याक गर्नुहोस् र प्रति चार्जर इतिहास राख्नुहोस्।',
  'Faults reported': 'जनाइएका खराबी',
  'Fetch this month\'s bill': 'यो महिनाको बिल ल्याउनुहोस्',
  'Fetched': 'ल्याइएको',
  'Firmware': 'फर्मवेयर',
  'Firmware & diagnostics': 'फर्मवेयर र डायग्नोस्टिक्स',
  'Firmware and diagnostics': 'फर्मवेयर र डायग्नोस्टिक्स',
  'Firmware update scheduled. The charger downloads and installs it, then restarts.': 'फर्मवेयर अद्यावधिक तय भयो। चार्जरले डाउनलोड र जडान गरेर फेरि सुरु हुन्छ।',
  'First come, first served': 'पहिले आउनेलाई पहिले',
  'First password': 'पहिलो पासवर्ड',
  'Flagged when the difference is more than {wh} Wh.': 'फरक {wh} Wh भन्दा बढी हुँदा चिन्ह लगाइन्छ।',
  'Fleet customers and VIP drivers can book a connector ahead. Reservations expire automatically and the charger refuses other cards while one is active. This needs B3 in the backend requests.': 'फ्लीट ग्राहक र VIP चालकले पहिल्यै कनेक्टर बुक गर्न सक्छन्। आरक्षणको म्याद आफैं सकिन्छ र सक्रिय रहँदा चार्जरले अरू कार्ड स्वीकार्दैन। यसका लागि ब्याकएन्ड अनुरोधमा B3 चाहिन्छ।',
  'For at least (minutes)': 'कम्तीमा (मिनेट)',
  'For example 017.15.435': 'उदाहरण: 017.15.435',
  'For example the cash receipt number. The customer sees this.': 'उदाहरण: नगद रसिद नम्बर। ग्राहकले यो देख्छन्।',
  'For example: charger stopped early, customer was overcharged': 'उदाहरण: चार्जर चाँडै रोकियो, ग्राहकबाट बढी लियो',
  'For sessions left open after a charger lost its connection. This changes the record only; it sends nothing to the charger.': 'चार्जरको जडान टुटेपछि खुला रहेका सत्रका लागि। यसले रेकर्ड मात्र बदल्छ; चार्जरमा केही पठाउँदैन।',
  'Free': 'खाली',
  'Free connectors': 'खाली कनेक्टर',
  'From': 'देखि',
  'Full name': 'पूरा नाम',
  'Gateway saved': 'गेटवे सुरक्षित भयो',
  'Get a notification, SMS or email the moment something needs attention, instead of hearing it from a driver.': 'चालकबाट सुन्नुअघि नै, ध्यान दिनुपर्ने कुरा हुनेबित्तिकै सूचना, SMS वा इमेल पाउनुहोस्।',
  'Give access': 'पहुँच दिनुहोस्',
  'Give station access': 'स्टेसन पहुँच दिनुहोस्',
  'Give the plan a name.': 'योजनाको नाम राख्नुहोस्।',
  'Give your station staff their own access instead of sharing your password.': 'आफ्नो पासवर्ड बाँड्नुको सट्टा स्टेसन कर्मचारीलाई छुट्टै पहुँच दिनुहोस्।',
  'Good afternoon': 'शुभ दिउँसो',
  'Good evening': 'शुभ साँझ',
  'Good morning': 'शुभ प्रभात',
  'Hard reset (reboot)': 'हार्ड रिसेट (रिबुट)',
  'Healthy': 'ठीक',
  'Heartbeat every (seconds)': 'हार्टबिट हरेक (सेकेन्ड)',
  'Held until': 'सम्म आरक्षित',
  'Hidden': 'लुकाइएको',
  'Hidden from drivers': 'चालकबाट लुकाइएको',
  'Hold a connector for a driver for a set time (OCPP ReserveNow). The charger shows it as reserved and only that card can start.': 'तोकिएको समयका लागि चालकको निम्ति कनेक्टर राख्नुहोस् (OCPP ReserveNow)। चार्जरले आरक्षित देखाउँछ र त्यही कार्डले मात्र सुरु गर्न सक्छ।',
  'Hold for (minutes)': 'राख्ने समय (मिनेट)',
  'Holder': 'धारक',
  'Hours (0–23, {tz})': 'घण्टा (०–२३, {tz})',
  'How it was priced': 'मूल्य कसरी निकालियो',
  'How much of the time each charger was online and able to charge. Drivers remember the chargers that let them down.': 'हरेक चार्जर कति समय अनलाइन र चार्ज गर्न सक्ने अवस्थामा थियो। धोका दिने चार्जर चालकले सम्झिरहन्छन्।',
  'How to share it': 'कसरी बाँड्ने',
  'In progress': 'चलिरहेको',
  'Inactive': 'निष्क्रिय',
  'Info': 'जानकारी',
  'Interrupted or failed': 'अवरुद्ध वा असफल',
  'Failed sessions': 'असफल सत्रहरू',
  '0 kWh and Rs 0': '० kWh र रु ०',
  'Issue an RFID card': 'RFID कार्ड जारी गर्नुहोस्',
  'Issue card': 'कार्ड जारी गर्नुहोस्',
  'Issue super card': 'सुपर कार्ड जारी गर्नुहोस्',
  'Issued': 'जारी गरिएको',
  'Joined': 'सामेल भएको',
  'Keep each station within its electricity connection by sharing power between the cars charging.': 'चार्ज हुँदै गरेका गाडीबीच बिजुली बाँडेर हरेक स्टेसनलाई आफ्नो बिजुली जडानभित्र राख्नुहोस्।',
  'Kept with the session for the record.': 'रेकर्डका लागि सत्रसँगै राखिन्छ।',
  'Key': 'कुञ्जी',
  'Kind': 'प्रकार',
  'Kind of plan': 'योजनाको प्रकार',
  'Language': 'भाषा',
  'Last 30 days': 'पछिल्लो ३० दिन',
  'Last 7 days': 'पछिल्लो ७ दिन',
  'Last 90 days': 'पछिल्लो ९० दिन',
  'Last changed': 'अन्तिम परिवर्तन',
  'Last event': 'अन्तिम घटना',
  'Last heartbeat': 'अन्तिम हार्टबिट',
  'Last month': 'गत महिना',
  'Last update': 'अन्तिम अद्यावधिक',
  'Last update {ago}': 'अन्तिम अद्यावधिक {ago}',
  'Leave empty to keep the current key.': 'हालको कुञ्जी राख्न खाली छोड्नुहोस्।',
  'Leave empty to keep the current one.': 'हालकै राख्न खाली छोड्नुहोस्।',
  'Level': 'तह',
  'Light': 'उज्यालो',
  'Listening for updates': 'अद्यावधिक पर्खँदै',
  'Live charges appear here as soon as a charger starts a session.': 'चार्जरले सत्र सुरु गर्नेबित्तिकै लाइभ चार्ज यहाँ देखिन्छ।',
  'Load limit saved': 'लोड सीमा सुरक्षित भयो',
  'Loading…': 'लोड हुँदै…',
  'Location': 'स्थान',
  'Lower limits at certain hours': 'केही घण्टामा कम सीमा',
  'Maintenance tickets': 'मर्मत टिकट',
  'Make default': 'पूर्वनिर्धारित बनाउनुहोस्',
  'Maker': 'निर्माता',
  'Map': 'नक्सा',
  'Max power (kW)': 'अधिकतम शक्ति (kW)',
  'Maximum power (kW)': 'अधिकतम शक्ति (kW)',
  'Maximum uses': 'अधिकतम प्रयोग',
  'Member since': 'सदस्य भएदेखि',
  'Merchant code': 'मर्चेन्ट कोड',
  'Message': 'सन्देश',
  'Meter': 'मिटर',
  'Meter anomalies': 'मिटर असामान्यता',
  'Meter mismatch': 'मिटर नमिलेको',
  'Meter saved': 'मिटर सुरक्षित भयो',
  'Meters linked to your stations and the bills fetched from NEA, so you can compare the electricity you pay for with what you sell.': 'तपाईंका स्टेसनसँग जोडिएका मिटर र NEA बाट ल्याइएका बिल, ताकि तिरेको र बेचेको बिजुली तुलना गर्न सकियोस्।',
  'Model': 'मोडेल',
  'More': 'थप',
  'More actions': 'थप कार्य',
  'Move or delete its chargers first': 'पहिले यसका चार्जर सार्नुहोस् वा मेटाउनुहोस्',
  'Moving the charger to another station?': 'चार्जर अर्को स्टेसनमा सार्दै हुनुहुन्छ?',
  'NEA electricity meter': 'NEA बिजुली मिटर',
  'NEA meter': 'NEA मिटर',
  'NEA office': 'NEA कार्यालय',
  'Name or email': 'नाम वा इमेल',
  'Name, email or phone': 'नाम, इमेल वा फोन',
  'Need attention': 'ध्यान चाहिने',
  'Network uptime': 'नेटवर्क अपटाइम',
  'Never': 'कहिल्यै होइन',
  'New alert': 'नयाँ सतर्कता',
  'New firmware file (URL)': 'नयाँ फर्मवेयर फाइल (URL)',
  'New password': 'नयाँ पासवर्ड',
  'New password again': 'नयाँ पासवर्ड फेरि',
  'New plan': 'नयाँ योजना',
  'New price plan': 'नयाँ मूल्य योजना',
  'New promotion': 'नयाँ प्रमोसन',
  'New status': 'नयाँ अवस्था',
  'New ticket': 'नयाँ टिकट',
  'New value': 'नयाँ मान',
  'Newer': 'नयाँ',
  'No': 'होइन',
  'No address': 'ठेगाना छैन',
  'No alert rules yet': 'अहिलेसम्म सतर्कता नियम छैन',
  'No alerts fired recently.': 'हालै कुनै सतर्कता आएको छैन।',
  'No anomalies': 'असामान्यता छैन',
  'No bills yet. Ask NEA for this month\'s bill; it arrives in a few minutes.': 'अहिलेसम्म बिल छैन। यो महिनाको बिल NEA सँग माग्नुहोस्; केही मिनेटमा आउँछ।',
  'No cards': 'कार्ड छैन',
  'No cards. Drivers can still start a charge from the app.': 'कार्ड छैन। चालकले एपबाट चार्ज सुरु गर्न सक्छन्।',
  'No charge running.': 'कुनै चार्ज चलिरहेको छैन।',
  'No chargers at this station': 'यो स्टेसनमा चार्जर छैन',
  'No chargers match': 'मिल्ने चार्जर छैन',
  'No chargers yet': 'अहिलेसम्म चार्जर छैन',
  'No charges yet': 'अहिलेसम्म शुल्क छैन',
  'No customer matches': 'मिल्ने ग्राहक छैन',
  'No customers yet': 'अहिलेसम्म ग्राहक छैन',
  'No diagnostics files yet.': 'अहिलेसम्म डायग्नोस्टिक्स फाइल छैन।',
  'No errors reported. All quiet.': 'कुनै त्रुटि छैन। सबै शान्त।',
  'No faults': 'खराबी छैन',
  'No meter added': 'मिटर थपिएको छैन',
  'No one found. They need to sign up in the Saadhan Charge app first.': 'कोही भेटिएन। पहिले साधन चार्ज एपमा साइन अप गर्नुपर्छ।',
  'No one is charging right now': 'अहिले कोही चार्ज गरिरहेको छैन',
  'No one matches': 'कोही मिलेन',
  'No online payments yet': 'अहिलेसम्म अनलाइन भुक्तानी छैन',
  'No operators': 'सञ्चालक छैन',
  'No photos yet': 'अहिलेसम्म तस्बिर छैन',
  'No price plans yet': 'अहिलेसम्म मूल्य योजना छैन',
  'No promotions yet': 'अहिलेसम्म प्रमोसन छैन',
  'No reservations': 'आरक्षण छैन',
  'No sessions in this period': 'यो अवधिमा सत्र छैन',
  'No sessions on this charger yet': 'यो चार्जरमा अहिलेसम्म सत्र छैन',
  'No sessions yet': 'अहिलेसम्म सत्र छैन',
  'No slides': 'स्लाइड छैन',
  'No station': 'स्टेसन छैन',
  'No stations yet': 'अहिलेसम्म स्टेसन छैन',
  'No super card charges since the last settlement.': 'अन्तिम हिसाबपछि सुपर कार्ड शुल्क छैन।',
  'No super cards yet': 'अहिलेसम्म सुपर कार्ड छैन',
  'No tickets': 'टिकट छैन',
  'No transactions in this period': 'यो अवधिमा कारोबार छैन',
  'No wallet activity yet': 'अहिलेसम्म वालेट गतिविधि छैन',
  'Nobody yet': 'अहिलेसम्म कोही छैन',
  'None': 'छैन',
  'Normal': 'सामान्य',
  'Normal hours price: {p}': 'सामान्य समयको मूल्य: {p}',
  'Not assigned to a station': 'स्टेसनमा तोकिएको छैन',
  'Not paid yet': 'अझै नतिरिएको',
  'Not set': 'राखिएको छैन',
  'Not set up': 'सेटअप गरिएको छैन',
  'Not yet': 'अझै छैन',
  'Note': 'टिप्पणी',
  'Notes': 'टिप्पणीहरू',
  'Nothing logged': 'केही लग छैन',
  'Nothing needs fixing right now.': 'अहिले केही सच्याउनुपर्ने छैन।',
  'Nothing recorded yet': 'अहिलेसम्म केही रेकर्ड छैन',
  'Nothing to settle': 'हिसाब गर्नुपर्ने केही छैन',
  'Notification sent': 'सूचना पठाइयो',
  'Number': 'नम्बर',
  'OCPP Basic Auth, so only your real charger can connect with this ID.': 'OCPP Basic Auth, ताकि यो ID बाट तपाईंको वास्तविक चार्जर मात्र जोडिन सकोस्।',
  'OCPP TriggerMessage': 'OCPP TriggerMessage',
  'OCPP log': 'OCPP लग',
  'OCPP server URL': 'OCPP सर्भर URL',
  'Off-peak': 'अफ-पिक',
  'Off-peak ends': 'अफ-पिक सकिने',
  'Off: no limit': 'बन्द: सीमा छैन',
  'Offline chargers': 'अफलाइन चार्जर',
  'Older': 'पुरानो',
  'On': 'मा',
  'One person': 'एक व्यक्ति',
  'Only you so far': 'अहिलेसम्म तपाईं मात्र',
  'Open': 'खुला',
  'Open 24 hours, every day': 'हरेक दिन २४ घण्टा खुला',
  'Open dashboard': 'ड्यासबोर्ड खोल्नुहोस्',
  'Open live view': 'लाइभ दृश्य खोल्नुहोस्',
  'Open to drivers': 'चालकका लागि खुला',
  'Opened': 'खोलिएको',
  'Opening hours': 'खुल्ने समय',
  'Opens': 'खुल्ने',
  'Operator': 'सञ्चालक',
  'Operator added. Send them their sign-in details.': 'सञ्चालक थपियो। उहाँलाई साइन इन विवरण पठाउनुहोस्।',
  'Operator owners': 'सञ्चालक मालिकहरू',
  'Operator removed': 'सञ्चालक हटाइयो',
  'Operators to pay': 'तिर्नुपर्ने सञ्चालक',
  'Other': 'अन्य',
  'Owed': 'बाँकी',
  'Owed to operators': 'सञ्चालकलाई तिर्न बाँकी',
  'Owed to you': 'तपाईंलाई तिर्न बाँकी',
  'Owner': 'मालिक',
  'Owner email': 'मालिकको इमेल',
  'Owner name': 'मालिकको नाम',
  'PAN / VAT number': 'PAN / VAT नम्बर',
  'PDF': 'PDF',
  'PDF report': 'PDF रिपोर्ट',
  'Parts of the price': 'मूल्यका भागहरू',
  'Password changed': 'पासवर्ड बदलियो',
  'Password set': 'पासवर्ड राखिएको',
  'Pause': 'रोक्नुहोस्',
  'Paused': 'रोकिएको',
  'Payment gateways': 'भुक्तानी गेटवे',
  'Payments': 'भुक्तानी',
  'Peak': 'पिक',
  'Peak ends': 'पिक सकिने',
  'Peak starts': 'पिक सुरु',
  'People': 'व्यक्तिहरू',
  'Per day, Nepal time': 'प्रति दिन, नेपाल समय',
  'Period': 'अवधि',
  'Person': 'व्यक्ति',
  'Photo removed': 'तस्बिर हटाइयो',
  'Photos': 'तस्बिरहरू',
  'Photos appear on the station page in the app. Up to 10, 5 MB each.': 'तस्बिर एपको स्टेसन पृष्ठमा देखिन्छन्। १० वटासम्म, हरेक ५ MB।',
  'Photos help drivers find the chargers.': 'तस्बिरले चालकलाई चार्जर भेट्टाउन मद्दत गर्छ।',
  'Photos uploaded': 'तस्बिर अपलोड भए',
  'Picture removed': 'तस्बिर हटाइयो',
  'Picture updated': 'तस्बिर अद्यावधिक भयो',
  'Plan': 'योजना',
  'Plan deleted': 'योजना मेटाइयो',
  'Plan saved': 'योजना सुरक्षित भयो',
  'Position': 'स्थान क्रम',
  'Power being delivered': 'दिइँदै गरेको शक्ति',
  'Preview': 'पूर्वावलोकन',
  'Price per kWh (Rs.)': 'प्रति kWh मूल्य (रू.)',
  'Price plans and which connectors use them. Connectors without a plan use the default plan.': 'मूल्य योजना र तिनलाई प्रयोग गर्ने कनेक्टर। योजना नभएका कनेक्टरले पूर्वनिर्धारित योजना प्रयोग गर्छन्।',
  'Pricing': 'मूल्य निर्धारण',
  'Pricing plan': 'मूल्य योजना',
  'Printed on receipts and shown to drivers.': 'रसिदमा छापिन्छ र चालकलाई देखाइन्छ।',
  'Printed on the card, or read it by tapping the card on a charger and checking the log.': 'कार्डमा छापिएको, वा चार्जरमा कार्ड छुवाएर लगमा हेर्नुहोस्।',
  'Priority': 'प्राथमिकता',
  'Problem': 'समस्या',
  'Profile saved': 'प्रोफाइल सुरक्षित भयो',
  'Promotion saved': 'प्रमोसन सुरक्षित भयो',
  'Protocol: OCPP 1.6J over WebSocket. Full address: {url}': 'प्रोटोकल: WebSocket मार्फत OCPP 1.6J। पूरा ठेगाना: {url}',
  'Put back in service': 'फेरि सेवामा ल्याउनुहोस्',
  'Put connector {n} back in service?': 'कनेक्टर {n} फेरि सेवामा ल्याउने?',
  'RFID card number': 'RFID कार्ड नम्बर',
  'Rate': 'दर',
  'Read again': 'फेरि पढ्नुहोस्',
  'Read and change the settings inside the charger (OCPP GetConfiguration and ChangeConfiguration): heartbeat and meter-value intervals, offline authorisation, connection timeouts. Also ask a charger to send a status or meter reading on demand (TriggerMessage). This needs B1 in the backend requests.': 'चार्जरभित्रका सेटिङ पढ्नुहोस् र बदल्नुहोस् (OCPP GetConfiguration र ChangeConfiguration): हार्टबिट र मिटर-मान अन्तराल, अफलाइन अनुमति, जडान टाइमआउट। चाहेको बेला चार्जरलाई अवस्था वा मिटर रिडिङ पठाउन पनि भन्नुहोस् (TriggerMessage)। यसका लागि ब्याकएन्ड अनुरोधमा B1 चाहिन्छ।',
  'Read only': 'पढ्न मात्र',
  'Reason': 'कारण',
  'Reboot': 'रिबुट',
  'Reboot {id}?': '{id} रिबुट गर्ने?',
  'Receipt footer': 'रसिदको फुटर',
  'Recent alerts': 'हालका सतर्कता',
  'Recent problems': 'हालका समस्या',
  'Recent sessions': 'हालका सत्र',
  'Reference': 'सन्दर्भ',
  'Refreshing every 10 seconds': 'हरेक १० सेकेन्डमा रिफ्रेस हुँदै',
  'Refund': 'फिर्ता',
  'Refund issued': 'फिर्ता गरियो',
  'Refund this session': 'यो सत्रको रकम फिर्ता',
  'Refund {amount}': '{amount} फिर्ता',
  'Refunded': 'फिर्ता गरिएको',
  'Refunds need a backend endpoint that is not live yet (BACKEND_REQUESTS B8). Until then, add the amount back with "Add credit" on the customer.': 'फिर्ताका लागि ब्याकएन्ड इन्डपोइन्ट चाहिन्छ जुन अझै छैन (BACKEND_REQUESTS B8)। त्यतिन्जेल ग्राहकमा "रकम थप्नुहोस्" बाट रकम फर्काउनुहोस्।',
  'Registered name': 'दर्ता नाम',
  'Remove': 'हटाउनुहोस्',
  'Remove access': 'पहुँच हटाउनुहोस्',
  'Remove access for {name}?': '{name} को पहुँच हटाउने?',
  'Remove card': 'कार्ड हटाउनुहोस्',
  'Remove card {n}?': 'कार्ड {n} हटाउने?',
  'Remove connector': 'कनेक्टर हटाउनुहोस्',
  'Remove contact': 'सम्पर्क हटाउनुहोस्',
  'Remove operator': 'सञ्चालक हटाउनुहोस्',
  'Remove photo': 'तस्बिर हटाउनुहोस्',
  'Remove picture': 'तस्बिर हटाउनुहोस्',
  'Remove {name}?': '{name} हटाउने?',
  'Removing access needs B14 in the backend requests. For now, move them to a station as Viewer.': 'पहुँच हटाउन ब्याकएन्ड अनुरोधमा B14 चाहिन्छ। अहिलेलाई उहाँलाई कुनै स्टेसनमा दर्शकको रूपमा सार्नुहोस्।',
  'Request file': 'फाइल माग्नुहोस्',
  'Required to connect': 'जोडिन आवश्यक',
  'Reservation cancelled': 'आरक्षण रद्द भयो',
  'Reserve': 'आरक्षण गर्नुहोस्',
  'Reserve a connector': 'कनेक्टर आरक्षण गर्नुहोस्',
  'Reset sent': 'रिसेट पठाइयो',
  'Resolved': 'समाधान भएको',
  'Resume': 'फेरि सुरु गर्नुहोस्',
  'Revenue (all time)': 'आम्दानी (सबै समय)',
  'Revenue by day': 'दैनिक आम्दानी',
  'Revenue on this page': 'यो पृष्ठको आम्दानी',
  'Revenue share': 'आम्दानीको हिस्सा',
  'Revenue today': 'आजको आम्दानी',
  'Revenue, 30 days': 'आम्दानी, ३० दिन',
  'Revenue, energy and sessions by station and charger.': 'स्टेसन र चार्जर अनुसार आम्दानी, ऊर्जा र सत्र।',
  'Revenue, last 30 days': 'आम्दानी, पछिल्लो ३० दिन',
  'Role': 'भूमिका',
  'Rs. / kWh': 'रू. / kWh',
  'Rs. per kWh': 'रू. प्रति kWh',
  'Rule': 'नियम',
  'Rules': 'नियमहरू',
  'Rules like "tell the station manager by SMS if a charger is offline for 15 minutes". The backend watches charger status and sends push, SMS or email to the people you pick. This needs B5 in the backend requests.': '"चार्जर १५ मिनेट अफलाइन भए स्टेसन प्रबन्धकलाई SMS गर्नू" जस्ता नियम। ब्याकएन्डले चार्जरको अवस्था हेर्छ र तपाईंले छानेका व्यक्तिलाई पुश, SMS वा इमेल पठाउँछ। यसका लागि ब्याकएन्ड अनुरोधमा B5 चाहिन्छ।',
  'SC number': 'SC नम्बर',
  'SMS credit left': 'बाँकी SMS क्रेडिट',
  'Saadhan cards that work at every station on the platform and pay from the Saadhan wallet. Operators are settled for these charges.': 'प्लेटफर्मका सबै स्टेसनमा चल्ने र साधन वालेटबाट तिर्ने साधन कार्ड। यी शुल्कको हिसाब सञ्चालकसँग मिलाइन्छ।',
  'Save plan': 'योजना सुरक्षित गर्नुहोस्',
  'Saved': 'सुरक्षित भयो',
  'Saved on this device only.': 'यो उपकरणमा मात्र सुरक्षित।',
  'Search by': 'यसबाट खोज्नुहोस्',
  'Search by charger ID or maker': 'चार्जर ID वा निर्माताबाट खोज्नुहोस्',
  'Search customers': 'ग्राहक खोज्नुहोस्',
  'Search offices': 'कार्यालय खोज्नुहोस्',
  'Search operators': 'सञ्चालक खोज्नुहोस्',
  'Secret key': 'गोप्य कुञ्जी',
  'Send': 'पठाउनुहोस्',
  'Send a message to phones with the Saadhan Charge app.': 'साधन चार्ज एप भएका फोनमा सन्देश पठाउनुहोस्।',
  'Send by': 'पठाउने माध्यम',
  'Send request': 'अनुरोध पठाउनुहोस्',
  'Send to': 'पठाउने',
  'Send to charger': 'चार्जरमा पठाउनुहोस्',
  'Send to everyone with this role?': 'यो भूमिका भएका सबैलाई पठाउने?',
  'Send to everyone?': 'सबैलाई पठाउने?',
  'Sent to chargers when they boot.': 'चार्जर सुरु हुँदा पठाइन्छ।',
  'Service charge (%)': 'सेवा शुल्क (%)',
  'Session': 'सत्र',
  'Session #{id}': 'सत्र #{id}',
  'Session updated': 'सत्र अद्यावधिक भयो',
  'Session {id}': 'सत्र {id}',
  'Sessions where the meter readings and the energy billed do not add up. Check each one and fix the status or refund if needed.': 'मिटर रिडिङ र बिल गरिएको ऊर्जा नमिलेका सत्र। हरेक जाँच्नुहोस् र आवश्यक परे अवस्था सच्याउनुहोस् वा रकम फिर्ता गर्नुहोस्।',
  'Sessions, 30 days': 'सत्र, ३० दिन',
  'Set a new password': 'नयाँ पासवर्ड राख्नुहोस्',
  'Set up': 'सेटअप',
  'Settings inside the charger': 'चार्जरभित्रका सेटिङ',
  'Settings saved': 'सेटिङ सुरक्षित भयो',
  'Settlement history and payout receipts need the payments work (B7). Until then, agree payouts with Saadhan Charge using this list.': 'हिसाबको इतिहास र भुक्तानी रसिदका लागि भुक्तानी काम (B7) चाहिन्छ। त्यतिन्जेल यो सूची प्रयोग गरी साधन चार्जसँग भुक्तानी मिलाउनुहोस्।',
  'Shared between the cars charging, so the station never draws more than its connection allows.': 'चार्ज हुँदै गरेका गाडीबीच बाँडिन्छ, ताकि स्टेसनले जडानले दिनेभन्दा बढी कहिल्यै नलिओस्।',
  'Shown in the app': 'एपमा देखाइने',
  'Since': 'देखि',
  'Slide deleted': 'स्लाइड मेटाइयो',
  'Slide saved': 'स्लाइड सुरक्षित भयो',
  'Soft reset': 'सफ्ट रिसेट',
  'Soft reset {id}?': '{id} सफ्ट रिसेट गर्ने?',
  'Some changes only take effect after the charger restarts.': 'केही परिवर्तन चार्जर फेरि सुरु भएपछि मात्र लागू हुन्छन्।',
  'Spent on charging (this page)': 'चार्जिङमा खर्च (यो पृष्ठ)',
  'Spreadsheet (CSV)': 'स्प्रेडसिट (CSV)',
  'Staff access': 'कर्मचारी पहुँच',
  'Start': 'सुरु',
  'Start charging': 'चार्ज सुरु गर्नुहोस्',
  'Start charging on {charger} #{n}': '{charger} #{n} मा चार्ज सुरु गर्नुहोस्',
  'Start sent to the charger': 'चार्जरमा सुरु पठाइयो',
  'Starts': 'सुरु हुने',
  'Station created': 'स्टेसन बनाइयो',
  'Station deleted': 'स्टेसन मेटाइयो',
  'Station managers': 'स्टेसन प्रबन्धकहरू',
  'Station managers and counter staff, and the station each one works at.': 'स्टेसन प्रबन्धक र काउन्टर कर्मचारी, र हरेकले काम गर्ने स्टेसन।',
  'Station name': 'स्टेसनको नाम',
  'Station operators': 'स्टेसन सञ्चालकहरू',
  'Station operators can start charges with their own card only.': 'स्टेसन सञ्चालकले आफ्नै कार्डबाट मात्र चार्ज सुरु गर्न सक्छन्।',
  'Station power limit': 'स्टेसनको शक्ति सीमा',
  'Station saved': 'स्टेसन सुरक्षित भयो',
  'Stations / chargers': 'स्टेसन / चार्जर',
  'Stations with a meter': 'मिटर भएका स्टेसन',
  'Still charging': 'अझै चार्ज हुँदै',
  'Stop': 'रोक्नुहोस्',
  'Stop charging': 'चार्ज रोक्नुहोस्',
  'Stop sent to the charger': 'चार्जरमा रोक्ने आदेश पठाइयो',
  'Stop this charge?': 'यो चार्ज रोक्ने?',
  'Successful': 'सफल',
  'Super cards': 'सुपर कार्ड',
  'Support email': 'सहायता इमेल',
  'Support phone': 'सहायता फोन',
  'System': 'प्रणाली',
  'Take connector {n} out of service?': 'कनेक्टर {n} सेवाबाट हटाउने?',
  'Take out of service': 'सेवाबाट हटाउनुहोस्',
  'Target rate': 'लक्षित दर',
  'Team': 'टोली',
  'Temperature': 'तापक्रम',
  'Text': 'पाठ',
  'The amount goes back to the wallet that paid for the charge, and appears in the customer\'s history.': 'रकम चार्ज तिरेको वालेटमा फर्कन्छ, र ग्राहकको इतिहासमा देखिन्छ।',
  'The backend already logs connector status changes and faults. An uptime report turns those, plus charger connects and disconnects, into the share of time each charger was available, the minutes it was offline and how many faults it had, so you can hold suppliers to their service agreements. This needs B10 in the backend requests.': 'ब्याकएन्डले कनेक्टरको अवस्था परिवर्तन र खराबी पहिल्यै रेकर्ड गर्छ। अपटाइम रिपोर्टले ती, र चार्जर जोडिएको र छुटेको समयलाई, हरेक चार्जर उपलब्ध रहेको समय, अफलाइन मिनेट र खराबी संख्यामा बदल्छ, ताकि आपूर्तिकर्तालाई सेवा सम्झौताअनुसार जवाफदेही बनाउन सकियोस्। यसका लागि ब्याकएन्ड अनुरोधमा B10 चाहिन्छ।',
  'The banner slides at the top of the Saadhan Charge app.': 'साधन चार्ज एपको माथिका ब्यानर स्लाइड।',
  'The card stops working at every charger. Past sessions are kept.': 'कार्डले कुनै पनि चार्जरमा काम गर्न छोड्छ। पुराना सत्र रहन्छन्।',
  'The charger ID must match exactly the ID set in the charger (its OCPP Charge Point ID).': 'चार्जर ID चार्जरमा राखिएको ID (OCPP Charge Point ID) सँग ठ्याक्कै मिल्नुपर्छ।',
  'The charger can no longer connect, and drivers stop seeing it. Past sessions are kept.': 'चार्जर अब जोडिन सक्दैन, र चालकले देख्न छोड्छन्। पुराना सत्र रहन्छन्।',
  'The charger finishes running charges, then restarts its software.': 'चार्जरले चलिरहेका चार्ज सकाउँछ, अनि सफ्टवेयर फेरि सुरु गर्छ।',
  'The charger forgets the cards it remembered and checks every card with the server again. Useful after blocking a card.': 'चार्जरले सम्झेका कार्ड बिर्सन्छ र हरेक कार्ड फेरि सर्भरसँग जाँच्छ। कार्ड रोकेपछि उपयोगी।',
  'The charger is offline. Configuration can be read once it reconnects.': 'चार्जर अफलाइन छ। फेरि जोडिएपछि कन्फिगरेसन पढ्न सकिन्छ।',
  'The charger restarts completely. Any running charge stops, and the charger is offline for a minute or two.': 'चार्जर पूर्ण रूपमा फेरि सुरु हुन्छ। चलिरहेको चार्ज रोकिन्छ, र चार्जर एक-दुई मिनेट अफलाइन हुन्छ।',
  'The charger starts as soon as it accepts. The card pays for the charge, so make sure the right customer is plugged in.': 'चार्जरले स्वीकार्नेबित्तिकै सुरु हुन्छ। कार्डले चार्ज तिर्छ, त्यसैले सही ग्राहकको गाडी जोडिएको छ भनी निश्चित गर्नुहोस्।',
  'The charger stops delivering energy and the customer is billed for what they used so far.': 'चार्जरले ऊर्जा दिन रोक्छ र ग्राहकलाई अहिलेसम्म प्रयोग गरेको बिल लाग्छ।',
  'The customer\'s card number, as printed on the card or shown on their profile.': 'ग्राहकको कार्ड नम्बर, कार्डमा छापिएको वा प्रोफाइलमा देखिएको।',
  'The kind cannot change. Create a new plan instead.': 'प्रकार बदल्न मिल्दैन। बरु नयाँ योजना बनाउनुहोस्।',
  'The old password stops working. Enter the new one in the charger straight away, or it cannot connect.': 'पुरानो पासवर्डले काम गर्न छोड्छ। तुरुन्तै चार्जरमा नयाँ हाल्नुहोस्, नत्र जोडिन सक्दैन।',
  'The same account you use in the Saadhan Charge app.': 'साधन चार्ज एपमा प्रयोग गर्ने उही खाता।',
  'The secret key is stored encrypted on the server and never shown again.': 'गोप्य कुञ्जी सर्भरमा इन्क्रिप्ट गरी राखिन्छ र फेरि कहिल्यै देखाइँदैन।',
  'The station disappears from the app. Past sessions are kept.': 'स्टेसन एपबाट हराउँछ। पुराना सत्र रहन्छन्।',
  'The station\'s NEA connection, used to fetch its electricity bills.': 'स्टेसनको NEA जडान, बिजुली बिल ल्याउन प्रयोग हुने।',
  'The two passwords differ.': 'दुई पासवर्ड फरक छन्।',
  'Their account and personal details are removed. Session records stay for accounting.': 'उहाँको खाता र व्यक्तिगत विवरण हटाइन्छ। हिसाबका लागि सत्र रेकर्ड रहन्छन्।',
  'Their stations and chargers disappear from the app and their staff lose access. This cannot be undone from the dashboard.': 'उहाँका स्टेसन र चार्जर एपबाट हराउँछन् र कर्मचारीको पहुँच जान्छ। यो ड्यासबोर्डबाट फर्काउन सकिँदैन।',
  'They become a regular driver again and can no longer open this dashboard.': 'उहाँ फेरि सामान्य चालक बन्नुहुन्छ र यो ड्यासबोर्ड खोल्न सक्नुहुन्न।',
  'They sign in to this dashboard with their Saadhan Charge app account.': 'उहाँ आफ्नो साधन चार्ज एप खाताबाट यो ड्यासबोर्डमा साइन इन गर्नुहुन्छ।',
  'This browser': 'यो ब्राउजर',
  'This cannot be taken back once sent.': 'पठाएपछि फिर्ता लिन सकिँदैन।',
  'This month': 'यो महिना',
  'This needs B15 in the backend requests.': 'यसका लागि ब्याकएन्ड अनुरोधमा B15 चाहिन्छ।',
  'This station still has {n} chargers. Move or delete them first.': 'यो स्टेसनमा अझै {n} चार्जर छन्। पहिले तिनलाई सार्नुहोस् वा मेटाउनुहोस्।',
  'Tick all': 'सबै छान्नुहोस्',
  'Ticked connectors charge with this plan. Unticking one moves it to the default plan.': 'छानिएका कनेक्टरले यो योजनामा चार्ज गर्छन्। हटाएमा पूर्वनिर्धारित योजनामा जान्छ।',
  'Ticket': 'टिकट',
  'Ticket created': 'टिकट बनाइयो',
  'Ticket updated': 'टिकट अद्यावधिक भयो',
  'Time': 'समय',
  'Time slots (Nepal time)': 'समय तालिका (नेपाल समय)',
  'Title': 'शीर्षक',
  'To': 'सम्म',
  'Today a driver\'s balance can only be added by staff at the counter. With payment gateways, drivers top up in the app and the money lands in your wallet bucket straight away, with every payment reconciled here. This needs B7 in the backend requests.': 'अहिले चालकको मौज्दात काउन्टरमा कर्मचारीले मात्र थप्न सक्छन्। भुक्तानी गेटवेसँग, चालकले एपमै रिचार्ज गर्छन् र पैसा तुरुन्तै तपाईंको वालेटमा आउँछ, हरेक भुक्तानी यहाँ मिलान हुन्छ। यसका लागि ब्याकएन्ड अनुरोधमा B7 चाहिन्छ।',
  'Top stations': 'उत्कृष्ट स्टेसन',
  'Topped up online': 'अनलाइन रिचार्ज',
  'Total owed': 'जम्मा बाँकी',
  'Turn off to hide the station from the app.': 'एपबाट स्टेसन लुकाउन बन्द गर्नुहोस्।',
  'Type': 'प्रकार',
  'Unblock': 'रोक हटाउनुहोस्',
  'Units': 'युनिट',
  'Units billed': 'बिल गरिएका युनिट',
  'Unlock': 'अनलक',
  'Unlock cable': 'केबल अनलक गर्नुहोस्',
  'Unlock sent': 'अनलक पठाइयो',
  'Unlock the cable on connector {n}?': 'कनेक्टर {n} को केबल अनलक गर्ने?',
  'Untick all': 'सबै हटाउनुहोस्',
  'Untitled': 'शीर्षकविहीन',
  'Up to {max}': '{max} सम्म',
  'Update a charger\'s firmware remotely (OCPP UpdateFirmware) and see its progress, and ask a charger for its diagnostics file (GetDiagnostics) to send to the manufacturer. This needs B1 in the backend requests.': 'टाढैबाट चार्जरको फर्मवेयर अद्यावधिक गर्नुहोस् (OCPP UpdateFirmware) र प्रगति हेर्नुहोस्, र निर्मातालाई पठाउन चार्जरसँग डायग्नोस्टिक्स फाइल माग्नुहोस् (GetDiagnostics)। यसका लागि ब्याकएन्ड अनुरोधमा B1 चाहिन्छ।',
  'Update firmware': 'फर्मवेयर अद्यावधिक गर्नुहोस्',
  'Updated': 'अद्यावधिक',
  'Updates every few seconds': 'हरेक केही सेकेन्डमा अद्यावधिक',
  'Upload photos': 'तस्बिर अपलोड गर्नुहोस्',
  'Use Edit': 'सम्पादन प्रयोग गर्नुहोस्',
  'Use this when a cable is stuck in the car or the charger. If a charge is running, the car may stop charging.': 'केबल गाडी वा चार्जरमा अड्किँदा यो प्रयोग गर्नुहोस्। चार्ज चलिरहेको छ भने गाडीले चार्ज गर्न छोड्न सक्छ।',
  'Used': 'प्रयोग भएको',
  'Usually your NEA connection or transformer size.': 'प्रायः तपाईंको NEA जडान वा ट्रान्सफर्मरको क्षमता।',
  'Valid': 'मान्य',
  'Valid from': 'देखि मान्य',
  'Valid until': 'सम्म मान्य',
  'Value': 'मान',
  'Version': 'संस्करण',
  'Via': 'मार्फत',
  'Voltage': 'भोल्टेज',
  'Wallet': 'वालेट',
  'Wallet credit across all operators and the Saadhan wallet.': 'सबै सञ्चालक र साधन वालेटको रकम।',
  'Wallet history': 'वालेट इतिहास',
  'Wallet with you': 'तपाईंसँगको वालेट',
  'Warning': 'चेतावनी',
  'What': 'के',
  'What Saadhan Charge owes each operator for super card charges at their stations.': 'सञ्चालकका स्टेसनमा सुपर कार्ड शुल्कबापत साधन चार्जले हरेक सञ्चालकलाई तिर्नुपर्ने रकम।',
  'What is wrong?': 'के समस्या छ?',
  'What operators pay NEA. Dynamic plans add the service charge on top.': 'सञ्चालकले NEA लाई तिर्ने। गतिशील योजनाले माथि सेवा शुल्क थप्छ।',
  'When': 'कहिले',
  'Who': 'को',
  'Who can do what': 'कसले के गर्न सक्छ',
  'Who changed what, and when: prices, cards, credit, staff access and charger commands.': 'कसले के र कहिले बदल्यो: मूल्य, कार्ड, रकम, कर्मचारी पहुँच र चार्जर आदेश।',
  'Whole station': 'सम्पूर्ण स्टेसन',
  'With a fault': 'खराबी भएको',
  'Worked out from the sessions export until the backend has a daily report (B13).': 'ब्याकएन्डमा दैनिक रिपोर्ट (B13) नआउन्जेल सत्र निर्यातबाट निकालिएको।',
  'Yes': 'हो',
  'Your card': 'तपाईंको कार्ड',
  'Your charging locations: what drivers see in the app, and how each is doing.': 'तपाईंका चार्जिङ स्थान: चालकले एपमा के देख्छन्, र हरेक कस्तो चलिरहेको छ।',
  'Your company details and how this dashboard looks.': 'तपाईंको कम्पनी विवरण र यो ड्यासबोर्ड कस्तो देखिन्छ।',
  'Your legal name, PAN/VAT number, address and support contacts, printed on receipts and invoices and shown to drivers in the app. This needs B12 in the backend requests.': 'तपाईंको कानुनी नाम, PAN/VAT नम्बर, ठेगाना र सहायता सम्पर्क, रसिद र बिलमा छापिने र एपमा चालकलाई देखाइने। यसका लागि ब्याकएन्ड अनुरोधमा B12 चाहिन्छ।',
  'Your merchant accounts. Money goes straight to you.': 'तपाईंका मर्चेन्ट खाता। पैसा सिधै तपाईंलाई आउँछ।',
  'Your message appears here.': 'तपाईंको सन्देश यहाँ देखिन्छ।',
  'Your network today, updated live as chargers report.': 'आज तपाईंको नेटवर्क, चार्जरले जनाउँदै जाँदा लाइभ अद्यावधिक।',
  'Your profile': 'तपाईंको प्रोफाइल',
  'added': 'थपियो',
  'deducted': 'कटाइयो',
  'e.g. Service charge': 'जस्तै: सेवा शुल्क',
  'e.g. Standard DC': 'जस्तै: स्ट्यान्डर्ड DC',
  'heartbeat {ago}': 'हार्टबिट {ago}',
  'last 7 days vs previous': 'पछिल्लो ७ दिन अघिल्लोसँग तुलना',
  'last seen {ago}': 'अन्तिम पटक {ago}',
  'now': 'अहिले',
  'resolved': 'समाधान भयो',
  'vs yesterday': 'हिजोसँग तुलना',
  'wide, 2:1': 'चौडा, २:१',
  '{amount} added to {name}': '{name} मा {amount} थपियो',
  '{amount} in 30 days': '३० दिनमा {amount}',
  '{amount} taken from {name}': '{name} बाट {amount} कटाइयो',
  '{amount} {done} for {name}': '{name} का लागि {amount} {done}',
  '{free} of {total} connectors free': '{total} मध्ये {free} कनेक्टर खाली',
  '{from}–{to} of {total}': '{total} मध्ये {from}–{to}',
  '{n} chargers': '{n} चार्जर',
  '{n} completed': '{n} सम्पन्न',
  '{n} connectors': '{n} कनेक्टर',
  '{n} connectors in total': 'जम्मा {n} कनेक्टर',
  '{n} connectors on {c} chargers': '{c} चार्जरमा {n} कनेक्टर',
  '{n} customers': '{n} ग्राहक',
  '{n} faulted connectors': '{n} खराब कनेक्टर',
  '{n} older sessions were left open on this connector. Close them with "Correct status" so the connector reads correctly.': 'यो कनेक्टरमा {n} पुराना सत्र खुला छन्। कनेक्टर सही देखिन "अवस्था सच्याउनुहोस्" बाट बन्द गर्नुहोस्।',
  '{n} problems': '{n} समस्या',
  '{n} selected': '{n} छानिएको',
  '{v} kWh free': '{v} kWh निःशुल्क',
  '{v} off': '{v} छुट',
  'Built from parts the driver sees on the receipt: energy, service charge, VAT.': 'चालकले रसिदमा देख्ने भागबाट बनेको: ऊर्जा, सेवा शुल्क, VAT।',
  'CCTV security': 'CCTV सुरक्षा',
  'Custom': 'आफ्नै',
  'Different prices for different hours, e.g. cheaper at night.': 'फरक घण्टामा फरक मूल्य, जस्तै राति सस्तो।',
  'EV showroom': 'EV शोरुम',
  'Flat rate': 'एउटै दर',
  'Hotel': 'होटल',
  'Itemised': 'विवरणसहित',
  'Lounge': 'लाउन्ज',
  'Manager': 'प्रबन्धक',
  'One price per kWh, any time.': 'जुनसुकै बेला प्रति kWh एउटै मूल्य।',
  'One price per kWh, like a flat rate.': 'एउटै दरजस्तै, प्रति kWh एउटै मूल्य।',
  'Parking': 'पार्किङ',
  'Public transport': 'सार्वजनिक यातायात',
  'Restaurant / cafe': 'रेस्टुरेन्ट / क्याफे',
  'Restroom': 'शौचालय',
  'Runs one station: chargers, prices of its connectors, sessions, reports and remote control.': 'एउटा स्टेसन चलाउँछ: चार्जर, कनेक्टरको मूल्य, सत्र, रिपोर्ट र रिमोट नियन्त्रण।',
  'Sees the station live and its sessions. Can start a charge with their own card.': 'स्टेसन लाइभ र यसका सत्र हेर्छ। आफ्नै कार्डबाट चार्ज सुरु गर्न सक्छ।',
  'Shop': 'पसल',
  'Snacks': 'खाजा',
  'Time of day': 'समय अनुसार',
  'Wi-Fi': 'Wi-Fi',
  'Works at the counter: sees the station live and starts or stops charges with their own card.': 'काउन्टरमा काम गर्छ: स्टेसन लाइभ हेर्छ र आफ्नै कार्डबाट चार्ज सुरु वा बन्द गर्छ।',

  // Phase 2
  'A staff card with credit': 'रकम भएको कर्मचारी कार्ड',
  'Accounting & payouts': 'हिसाब र भुक्तानी',
  'Accounting export': 'हिसाब निर्यात',
  'Add a driver': 'चालक थप्नुहोस्',
  'Add credit to the fleet wallet': 'फ्लीट वालेटमा रकम थप्नुहोस्',
  'Add driver': 'चालक थप्नुहोस्',
  'Add taxi companies, delivery firms or offices that charge often.': 'प्रायः चार्ज गर्ने ट्याक्सी कम्पनी, डेलिभरी फर्म वा कार्यालय थप्नुहोस्।',
  'After a charge, drivers can rate the station from 1 to 5, write a review and add photos. Reviews show on the station page in the website and app. You reply here and can hide abusive ones. This needs B20 in the backend requests.': 'चार्जपछि चालकले स्टेसनलाई १ देखि ५ सम्म मूल्याङ्कन गर्न, समीक्षा लेख्न र तस्बिर थप्न सक्छन्। समीक्षा वेबसाइट र एपको स्टेसन पृष्ठमा देखिन्छ। तपाईं यहाँ जवाफ दिनुहुन्छ र अपमानजनक समीक्षा लुकाउन सक्नुहुन्छ। यसका लागि ब्याकएन्ड अनुरोधमा B20 चाहिन्छ।',
  'All kinds': 'सबै प्रकार',
  'All ratings': 'सबै मूल्याङ्कन',
  'Average charge': 'औसत चार्ज',
  'Average number of connectors charging, by weekday and hour (Nepal time)': 'बार र घण्टा अनुसार चार्ज हुँदै गरेका कनेक्टरको औसत संख्या (नेपाल समय)',
  'Average rating': 'औसत मूल्याङ्कन',
  'Back': 'पछाडि',
  'Balance / to invoice': 'मौज्दात / बिल गर्न बाँकी',
  'Bank reference': 'बैंक सन्दर्भ',
  'Bay is marked and lit at night': 'पार्किङ ठाउँ चिन्ह लगाइएको र रातमा उज्यालो छ',
  'Billed by NEA but not sold': 'NEA ले बिल गरेको तर नबेचिएको',
  'Billing': 'बिलिङ',
  'Billing email': 'बिलिङ इमेल',
  'Bring a new charger into service step by step: register it, connect it, check it on site and run a test charge.': 'नयाँ चार्जरलाई चरणबद्ध रूपमा सेवामा ल्याउनुहोस्: दर्ता, जडान, स्थलगत जाँच र परीक्षण चार्ज।',
  'Busiest time': 'सबैभन्दा व्यस्त समय',
  'Business customers whose drivers charge on one company account.': 'एउटै कम्पनी खातामा चालकहरूले चार्ज गर्ने व्यावसायिक ग्राहक।',
  'Busy': 'व्यस्त',
  'Cables and connector heads undamaged; holsters fitted': 'केबल र कनेक्टर क्षतिविहीन; होल्डर जडान',
  'Charger ID, price and QR code sticker in place': 'चार्जर ID, मूल्य र QR कोड स्टिकर टाँसिएको',
  'Charger connects': 'चार्जर जोडिन्छ',
  'Charger is mounted firmly and protected from vehicles': 'चार्जर बलियोसँग जडान र गाडीबाट सुरक्षित',
  'Chargers not used': 'प्रयोग नभएका चार्जर',
  'Charges Saadhan Charge owes you for, not yet paid out.': 'साधन चार्जले तपाईंलाई तिर्न बाँकी, अझै नतिरिएका शुल्क।',
  'Charges on the fleet account': 'फ्लीट खातामा लागेका शुल्क',
  'Charging hours': 'चार्जिङ घण्टा',
  'Charging on connector {n}: {e} so far. Energy is counted, so the meter works.': 'कनेक्टर {n} मा चार्ज हुँदै: अहिलेसम्म {e}। ऊर्जा गनिँदैछ, त्यसैले मिटरले काम गर्छ।',
  'Charging stops being allowed when unpaid use reaches this.': 'नतिरिएको प्रयोग यति पुगेपछि चार्ज गर्न दिइँदैन।',
  'Checked by {who} on {d}.': '{d} मा {who} द्वारा जाँचिएको।',
  'Cheque or bank transfer number.': 'चेक वा बैंक ट्रान्सफर नम्बर।',
  'Choose a conversation': 'कुराकानी छान्नुहोस्',
  'Commission a new charger': 'नयाँ चार्जर सञ्चालनमा ल्याउनुहोस्',
  'Commission {id}': '{id} सञ्चालनमा ल्याउने',
  'Commissioning': 'सञ्चालन सुरुवात',
  'Commissioning record saved': 'सञ्चालन सुरुवात रेकर्ड सुरक्षित भयो',
  'Company': 'कम्पनी',
  'Connected; last message {ago}.': 'जोडिएको; अन्तिम सन्देश {ago}।',
  'Connection': 'जडान',
  'Connectors report their status': 'कनेक्टरले अवस्था जनाउँछन्',
  'Connectors without a plan charge the default price.': 'योजना नभएका कनेक्टरमा पूर्वनिर्धारित मूल्य लाग्छ।',
  'Contact': 'सम्पर्क',
  'Contact person': 'सम्पर्क व्यक्ति',
  'Contact phone': 'सम्पर्क फोन',
  'Create invoice': 'बिल बनाउनुहोस्',
  'Create maintenance ticket': 'मर्मत टिकट बनाउनुहोस्',
  'Credit added': 'रकम थपियो',
  'Credit added at the counter, charging deductions and refunds, with balances.': 'काउन्टरमा थपिएको रकम, चार्जिङ कटौती र फिर्ता, मौज्दातसहित।',
  'Credit limit (Rs.)': 'उधारो सीमा (रू.)',
  'Daily summary': 'दैनिक सारांश',
  'Default price': 'पूर्वनिर्धारित मूल्य',
  'Driver added': 'चालक थपियो',
  'Driver removed from the fleet': 'चालक फ्लीटबाट हटाइयो',
  'Drivers in fleets': 'फ्लीटमा रहेका चालक',
  'Drivers on this account': 'यो खातामा रहेका चालक',
  'Each payout Saadhan Charge makes to you, for which period and sessions, with the bank reference, so you can match it to your bank statement. This needs B17 in the backend requests.': 'साधन चार्जले तपाईंलाई गर्ने हरेक भुक्तानी, कुन अवधि र सत्रका लागि, बैंक सन्दर्भसहित, ताकि बैंक विवरणसँग मिलाउन सकियोस्। यसका लागि ब्याकएन्ड अनुरोधमा B17 चाहिन्छ।',
  'Earthing measured and within limits': 'अर्थिङ नापिएको र सीमाभित्र',
  'Energy lost': 'गुमेको ऊर्जा',
  'Every charge with VAT split, one row per session.': 'VAT छुट्याइएको हरेक चार्ज, प्रति सत्र एक पङ्क्ति।',
  'Every driver has an answer.': 'सबै चालकले जवाफ पाएका छन्।',
  'Fleet accounts': 'फ्लीट खाता',
  'Fleet discount (%)': 'फ्लीट छुट (%)',
  'Fleet saved': 'फ्लीट सुरक्षित भयो',
  'Fleet wallet': 'फ्लीट वालेट',
  'Fleets': 'फ्लीटहरू',
  'Fri': 'शुक्र',
  'Hide': 'लुकाउनुहोस्',
  'Hours': 'घण्टा',
  'How much of the time your connectors are charging, and when they are busiest.': 'तपाईंका कनेक्टर कति समय चार्ज गरिरहेका छन्, र कहिले सबैभन्दा व्यस्त हुन्छन्।',
  'How they pay': 'उहाँहरू कसरी तिर्नुहुन्छ',
  'In the charger\'s network settings, set the OCPP server and Charge Point ID below, then restart it. This step ticks itself when the charger connects.': 'चार्जरको नेटवर्क सेटिङमा तलको OCPP सर्भर र Charge Point ID राख्नुहोस्, अनि फेरि सुरु गर्नुहोस्। चार्जर जोडिएपछि यो चरण आफैं पूरा हुन्छ।',
  'Installer, serial number, breaker size, anything to remember': 'जडानकर्ता, सिरियल नम्बर, ब्रेकरको क्षमता, सम्झनुपर्ने कुरा',
  'Invoice': 'बिल',
  'Invoice created': 'बिल बनाइयो',
  'Invoice updated': 'बिल अद्यावधिक भयो',
  'Invoices': 'बिलहरू',
  'Issue': 'जारी गर्नुहोस्',
  'Last 12 months': 'पछिल्लो १२ महिना',
  'Last 3 months': 'पछिल्लो ३ महिना',
  'Last 6 months': 'पछिल्लो ६ महिना',
  'Link this station’s NEA meter to see its electricity cost.': 'बिजुली लागत हेर्न यो स्टेसनको NEA मिटर जोड्नुहोस्।',
  'Margin': 'नाफा',
  'Margin by station': 'स्टेसन अनुसार नाफा',
  'Margin per station': 'प्रति स्टेसन नाफा',
  'Mark as passed': 'उत्तीर्ण चिन्ह लगाउनुहोस्',
  'Mark paid': 'तिरेको चिन्ह लगाउनुहोस्',
  'Mark resolved': 'समाधान भएको चिन्ह लगाउनुहोस्',
  'Mark {n} as paid': '{n} तिरेको चिन्ह लगाउनुहोस्',
  'Messages from drivers across every operator.': 'सबै सञ्चालकका चालकहरूबाट आएका सन्देश।',
  'Mon': 'सोम',
  'Month': 'महिना',
  'Monthly files for your accountant, and the money Saadhan Charge pays you for super card charges.': 'लेखापालका लागि मासिक फाइल, र सुपर कार्ड शुल्कबापत साधन चार्जले तपाईंलाई तिर्ने रकम।',
  'Monthly invoice': 'मासिक बिल',
  'Monthly limit': 'मासिक सीमा',
  'Monthly limit (Rs., optional)': 'मासिक सीमा (रू., ऐच्छिक)',
  'NEA bill': 'NEA बिल',
  'NEA units': 'NEA युनिट',
  'Network utilisation': 'नेटवर्क उपयोग',
  'Never connected': 'कहिल्यै जोडिएको छैन',
  'New fleet': 'नयाँ फ्लीट',
  'No drivers yet': 'अहिलेसम्म चालक छैन',
  'No fleets yet': 'अहिलेसम्म फ्लीट छैन',
  'No invoices yet': 'अहिलेसम्म बिल छैन',
  'No messages': 'सन्देश छैन',
  'No meter': 'मिटर छैन',
  'No payouts yet': 'अहिलेसम्म भुक्तानी छैन',
  'No reviews yet': 'अहिलेसम्म समीक्षा छैन',
  'Nothing open': 'खुला केही छैन',
  'Nothing owed': 'तिर्न बाँकी केही छैन',
  'OCPP 1.6J over WebSocket. Needs internet: SIM or Ethernet with a stable connection.': 'WebSocket मार्फत OCPP 1.6J। इन्टरनेट चाहिन्छ: स्थिर SIM वा Ethernet।',
  'On-site checks': 'स्थलगत जाँच',
  'One invoice per Nepali month, with VAT, for the company’s accounts.': 'कम्पनीको हिसाबका लागि प्रति नेपाली महिना VAT सहित एउटा बिल।',
  'Open checklist': 'जाँचसूची खोल्नुहोस्',
  'Owed to you now': 'अहिले तपाईंलाई तिर्न बाँकी',
  'Paid out so far': 'अहिलेसम्म तिरिएको',
  'Paid to NEA': 'NEA लाई तिरेको',
  'Paid {d}': '{d} मा तिरियो',
  'Passed on {d} by {who}.': '{d} मा {who} द्वारा उत्तीर्ण।',
  'Pay operators what super card charges at their stations earned, and keep the bank reference.': 'सञ्चालकका स्टेसनमा सुपर कार्ड शुल्कबाट कमाएको रकम तिर्नुहोस्, र बैंक सन्दर्भ राख्नुहोस्।',
  'Payment or refund': 'भुक्तानी वा फिर्ता',
  'Payment reference': 'भुक्तानी सन्दर्भ',
  'Payout history': 'भुक्तानी इतिहास',
  'Payout recorded': 'भुक्तानी रेकर्ड भयो',
  'Payouts': 'भुक्तानीहरू',
  'Payouts from Saadhan Charge': 'साधन चार्जबाट भुक्तानी',
  'Pending': 'बाँकी',
  'Per kWh sold': 'प्रति kWh बिक्री',
  'Plug in a car first. The charge is billed to the card like any other; refund it afterwards if needed.': 'पहिले गाडी जोड्नुहोस्। चार्ज अरूजस्तै कार्डमा बिल हुन्छ; आवश्यक परे पछि फिर्ता गर्नुहोस्।',
  'Post reply': 'जवाफ पोस्ट गर्नुहोस्',
  'Prepaid': 'पूर्वभुक्तानी',
  'Prepaid balances': 'पूर्वभुक्तानी मौज्दात',
  'Prepaid: shared fleet wallet': 'पूर्वभुक्तानी: साझा फ्लीट वालेट',
  'Prices include VAT': 'मूल्यमा VAT समावेश',
  'Print report': 'रिपोर्ट प्रिन्ट गर्नुहोस्',
  'Problem at a charger': 'चार्जरमा समस्या',
  'Protection (MCB / RCD) and emergency stop tested': 'सुरक्षा (MCB / RCD) र आपतकालीन स्टप जाँचिएको',
  'Question': 'प्रश्न',
  'Questions and problem reports from drivers at your stations.': 'तपाईंका स्टेसनका चालकहरूका प्रश्न र समस्या रिपोर्ट।',
  'Quiet': 'शान्त',
  'Rating': 'मूल्याङ्कन',
  'Record': 'रेकर्ड गर्नुहोस्',
  'Record a payout': 'भुक्तानी रेकर्ड गर्नुहोस्',
  'Record payout': 'भुक्तानी रेकर्ड गर्नुहोस्',
  'Recording a payout marks those super card charges as settled, so the operator’s “owed” goes back to zero and both sides see the same bank reference. This needs B17 in the backend requests.': 'भुक्तानी रेकर्ड गर्दा ती सुपर कार्ड शुल्क मिलान भएको मानिन्छ, ताकि सञ्चालकको "बाँकी" शून्यमा फर्कन्छ र दुवै पक्षले उही बैंक सन्दर्भ देख्छन्। यसका लागि ब्याकएन्ड अनुरोधमा B17 चाहिन्छ।',
  'Registered in Saadhan Charge': 'साधन चार्जमा दर्ता',
  'Remove this driver from the fleet?': 'यो चालकलाई फ्लीटबाट हटाउने?',
  'Reopen': 'फेरि खोल्नुहोस्',
  'Reply': 'जवाफ',
  'Reply posted': 'जवाफ पोस्ट भयो',
  'Revenue (months with a bill)': 'आम्दानी (बिल भएका महिना)',
  'Reviews': 'समीक्षाहरू',
  'Sales are counted in the Nepali month the charge started. NEA bills are matched to the month they are labelled with, which follows the meter reading day, so a few days can fall in the neighbouring month. Margin only counts months that have a bill. Energy lost is the station’s own use (lights, cooling, standby) plus losses between the meter and the cars.': 'बिक्री चार्ज सुरु भएको नेपाली महिनामा गनिन्छ। NEA बिल त्यसमा लेखिएको महिनासँग मिलाइन्छ, जुन मिटर रिडिङ दिनअनुसार हुन्छ, त्यसैले केही दिन छिमेकी महिनामा पर्न सक्छन्। नाफा बिल भएका महिनाको मात्र गनिन्छ। गुमेको ऊर्जा भनेको स्टेसनको आफ्नै प्रयोग (बत्ती, कुलिङ, स्ट्यान्डबाइ) र मिटरदेखि गाडीसम्मको क्षति हो।',
  'Sales register': 'बिक्री दर्ता',
  'Sat': 'शनि',
  'Save progress': 'प्रगति सुरक्षित गर्नुहोस्',
  'Saving the record needs B18 in the backend requests. Until then, use Print report to keep a copy.': 'रेकर्ड सुरक्षित गर्न ब्याकएन्ड अनुरोधमा B18 चाहिन्छ। त्यतिन्जेल प्रतिलिपि राख्न रिपोर्ट प्रिन्ट गर्नुहोस्।',
  'Send reply': 'जवाफ पठाउनुहोस्',
  'Sessions, kWh and sales per station per day: easy to post as daily journal entries.': 'प्रति स्टेसन प्रति दिन सत्र, kWh र बिक्री: दैनिक जर्नलमा चढाउन सजिलो।',
  'Share of connector time spent charging': 'कनेक्टरको समयमध्ये चार्जिङमा बितेको हिस्सा',
  'Show': 'देखाउनुहोस्',
  'Sign off': 'स्वीकृति',
  'Sold': 'बेचिएको',
  'Spent this month': 'यो महिना खर्च',
  'Spreadsheets for one Nepali month, ready for Tally or your accountant.': 'एउटा नेपाली महिनाको स्प्रेडसिट, Tally वा लेखापालका लागि तयार।',
  'Start test charge': 'परीक्षण चार्ज सुरु गर्नुहोस्',
  'Statements': 'विवरणहरू',
  'Stop test charge': 'परीक्षण चार्ज रोक्नुहोस्',
  'Sun': 'आइत',
  'Super card charges at your stations are paid to your bank account. Check each payout against your bank statement.': 'तपाईंका स्टेसनका सुपर कार्ड शुल्क तपाईंको बैंक खातामा तिरिन्छ। हरेक भुक्तानी बैंक विवरणसँग जाँच्नुहोस्।',
  'Super card statement': 'सुपर कार्ड विवरण',
  'Support inbox': 'सहायता इनबक्स',
  'Test card number': 'परीक्षण कार्ड नम्बर',
  'Test charge': 'परीक्षण चार्ज',
  'Test charge delivered {e}.': 'परीक्षण चार्जले {e} दियो।',
  'Thank them, or say what you have fixed. Everyone can see your reply.': 'धन्यवाद दिनुहोस्, वा के सुधार्नुभयो भन्नुहोस्। सबैले तपाईंको जवाफ देख्छन्।',
  'The sales files use the sessions export, which allows 5 downloads a minute.': 'बिक्री फाइलले सत्र निर्यात प्रयोग गर्छ, जसमा मिनेटमा ५ पटक डाउनलोड गर्न मिल्छ।',
  'Their cards go back to charging their own wallet.': 'उहाँका कार्डले फेरि आफ्नै वालेटबाट तिर्छन्।',
  'Their own cards charge to the fleet. Remove a driver when they leave the company.': 'उहाँहरूका आफ्नै कार्डको शुल्क फ्लीटमा जान्छ। कम्पनी छोडेपछि चालक हटाउनुहोस्।',
  'They need a Saadhan Charge account and a card from you.': 'उहाँलाई साधन चार्ज खाता र तपाईंबाट कार्ड चाहिन्छ।',
  'Thu': 'बिही',
  'Ticket #{id}': 'टिकट #{id}',
  'To invoice (postpaid)': 'बिल गर्न बाँकी (पछि भुक्तानी)',
  'Total': 'जम्मा',
  'Total = energy at the fleet price, minus the fleet discount, plus 13% VAT.': 'जम्मा = फ्लीट मूल्यमा ऊर्जा, फ्लीट छुट घटाएर, १३% VAT थपेर।',
  'Tue': 'मङ्गल',
  'Unknown': 'थाहा छैन',
  'Used, not yet invoiced': 'प्रयोग भएको, बिल नभएको',
  'Utilisation': 'उपयोग',
  'VAT rate (%)': 'VAT दर (%)',
  'Waiting for a reply': 'जवाफ पर्खँदै',
  'Waiting for driver': 'चालक पर्खँदै',
  'Waiting for parts': 'पार्टपुर्जा पर्खँदै',
  'Waiting for the charger': 'चार्जर पर्खँदै',
  'Wallet ledger': 'वालेट खाता',
  'Wed': 'बुध',
  'What drivers say about your stations. Reply in public, and hide anything abusive.': 'तपाईंका स्टेसनबारे चालकहरू के भन्छन्। सार्वजनिक रूपमा जवाफ दिनुहोस्, र अपमानजनक कुरा लुकाउनुहोस्।',
  'What you sold against what NEA billed you for the same Nepali month.': 'उही नेपाली महिनामा तपाईंले बेचेको र NEA ले बिल गरेको तुलना।',
  'When connectors are busy': 'कनेक्टर कहिले व्यस्त हुन्छन्',
  'Worked out from the sessions export. Utilisation counts time from start to stop, including the end of a charge when the car takes little power. The bar is drawn at twice scale, so 50% fills it.': 'सत्र निर्यातबाट निकालिएको। उपयोगले सुरुदेखि अन्त्यसम्मको समय गन्छ, गाडीले थोरै शक्ति लिने चार्जको अन्तिम भाग पनि। पट्टी दोब्बर स्केलमा छ, त्यसैले ५०% मा भरिन्छ।',
  'Write a reply. The driver gets a notification.': 'जवाफ लेख्नुहोस्। चालकले सूचना पाउँछन्।',
  'Your reply': 'तपाईंको जवाफ',
  '{from} to {to}, Nepal time.': '{from} देखि {to} सम्म, नेपाल समय।',
  '{n} connectors busy on average': 'औसतमा {n} कनेक्टर व्यस्त',
  '{n} connectors set up. The ID must match the Charge Point ID set inside the charger.': '{n} कनेक्टर सेटअप। ID चार्जरभित्र राखिएको Charge Point ID सँग मिल्नुपर्छ।',
  '{p} discount': '{p} छुट',
  '{p} of revenue': 'आम्दानीको {p}',
  '{p} of the credit limit': 'उधारो सीमाको {p}',
  // NEA bill upload
  "Also change {station}'s saved meter to this office": "{station} को सेभ गरिएको मिटर पनि यो कार्यालयमा बदल्नुहोस्",
  "Choose the PDF of the bill. Photos and screenshots can’t be read.": "बिलको PDF छान्नुहोस्। फोटो र स्क्रिनसट पढ्न सकिँदैन।",
  "Bill deleted": "बिल हटाइयो",
  "No bills yet. Upload the bill PDF from NEA when it arrives.": "अहिलेसम्म कुनै बिल छैन। NEA बाट बिल आएपछि यसको PDF अपलोड गर्नुहोस्।",
  "incl. VAT {vat}": "भ्याट {vat} सहित",
  "From PDF": "PDF बाट",
  "Open the bill PDF": "बिलको PDF खोल्नुहोस्",
  "Delete bill": "बिल हटाउनुहोस्",
  "Delete the bill for {period}?": "{period} को बिल हटाउने?",
  "You can upload it again later.": "पछि फेरि अपलोड गर्न सक्नुहुन्छ।",
  "The station's NEA connection and its electricity bills.": "स्टेसनको NEA जडान र यसका बिजुली बिलहरू।",
  "Upload bill": "बिल अपलोड गर्नुहोस्",
  "Upload a bill PDF from NEA and the meter is filled in from it, or add the NEA office, SC number and consumer ID yourself.": "NEA को बिल PDF अपलोड गर्नुहोस्, मिटर त्यसैबाट भरिन्छ। वा NEA कार्यालय, SC नम्बर र ग्राहक आईडी आफैं थप्नुहोस्।",
  "Bill saved": "बिल सेभ भयो",
  "Upload NEA bill": "NEA बिल अपलोड गर्नुहोस्",
  "For {station}. The bill PDF from NEA or the NEA app.": "{station} को लागि। NEA वा NEA एपबाट आएको बिल PDF।",
  "The bill PDF from NEA or the NEA app.": "NEA वा NEA एपबाट आएको बिल PDF।",
  "Save bill": "बिल सेभ गर्नुहोस्",
  "Bill PDF": "बिल PDF",
  "Choose the bill PDF": "बिल PDF छान्नुहोस्",
  "Reading the bill…": "बिल पढ्दै…",
  "Choose another file": "अर्को फाइल छान्नुहोस्",
  "Or drop it here": "वा यहाँ छोड्नुहोस्",
  "Read from the bill": "बिलबाट पढिएको",
  "Bill of": "बिल महिना",
  "issued {date}": "{date} मा जारी",
  "Consumer": "ग्राहक",
  "Amount before VAT": "भ्याट अघिको रकम",
  "VAT": "भ्याट",
  "Net bill amount": "कुल बिल रकम",
  "Matched by the SC number on the bill.": "बिलको SC नम्बरबाट मिलाइएको।",
  "No station has this SC number yet. Choose one, or leave it empty.": "कुनै स्टेसनमा यो SC नम्बर छैन। एउटा छान्नुहोस्, वा खाली छोड्नुहोस्।",
  "The station's NEA office.": "स्टेसनको NEA कार्यालय।",
  "Not printed on the bill as a code. Suggested from \"{office}\"; check it is right.": "बिलमा कोडको रूपमा छापिएको छैन। \"{office}\" बाट सुझाव दिइएको; सही हो कि जाँच्नुहोस्।",
  "Not printed on the bill. Choose the office that issues it.": "बिलमा छापिएको छैन। बिल जारी गर्ने कार्यालय छान्नुहोस्।",
  "This bill is for SC {sc}, but {station}'s meter is {meter}. Choose another station, or correct the meter first.": "यो बिल SC {sc} को हो, तर {station} को मिटर {meter} हो। अर्को स्टेसन छान्नुहोस्, वा पहिले मिटर सच्याउनुहोस्।",
  "Save this office, SC number and consumer ID as {station}'s meter": "यो कार्यालय, SC नम्बर र ग्राहक आईडी {station} को मिटरको रूपमा सेभ गर्नुहोस्",
  "A bill for {period} is already saved for this meter.": "यो मिटरको {period} को बिल पहिले नै सेभ छ।",
  "Replace it with this one": "यसैले बदल्नुहोस्",
  "Meters linked to your stations and their NEA bills, so you can compare the electricity you pay for with what you sell.": "तपाईंका स्टेसनसँग जोडिएका मिटर र तिनका NEA बिलहरू, ताकि तिर्ने बिजुली र बेचेको बिजुली तुलना गर्न सकियोस्।",
  // Superadmin overview
  "{n} charges": "{n} चार्ज",
  "Energy, last 30 days": "ऊर्जा, पछिल्लो ३० दिन",
  "Charges, last 30 days": "चार्ज, पछिल्लो ३० दिन",
  "{n} new in 30 days": "३० दिनमा {n} नयाँ",
  "Open an operator to see their dashboard as they do.": "सञ्चालकको ड्यासबोर्ड उनीहरूले जस्तै हेर्न खोल्नुहोस्।",
  "See all": "सबै हेर्नुहोस्",
  "Every charger is online.": "सबै चार्जर अनलाइन छन्।",
  "Last seen": "अन्तिम पटक देखिएको",
  "Latest charges": "पछिल्ला चार्जहरू",
  "Where": "कहाँ",
  "No charges yet.": "अहिलेसम्म कुनै चार्ज छैन।",
  // Page failed to load
  "A new version of the dashboard is ready": "ड्यासबोर्डको नयाँ संस्करण तयार छ",
  "Reload to get it. Nothing you saved is lost.": "पाउन रिलोड गर्नुहोस्। सेभ गरेको केही हराउँदैन।",
  "Something went wrong": "केही गडबड भयो",
  "Reload the page. If it keeps happening, tell us what you were doing.": "पेज रिलोड गर्नुहोस्। बारम्बार भइरहे के गर्दै हुनुहुन्थ्यो हामीलाई भन्नुहोस्।",
  "Reload": "रिलोड",
  "Go to the dashboard": "ड्यासबोर्डमा जानुहोस्",
  // NEA billing day
  "The {month} bill should be out (NEA bills this meter on day {day} of each Nepali month). Upload it when you have it.": "{month} को बिल आइसकेको हुनुपर्छ (NEA ले यो मिटरको बिल हरेक नेपाली महिनाको {day} गते निकाल्छ)। पाएपछि अपलोड गर्नुहोस्।",
  "NEA bills this meter on day {day} of each Nepali month. Next bill around {date} ({bs} BS).": "NEA ले यो मिटरको बिल हरेक नेपाली महिनाको {day} गते निकाल्छ। अर्को बिल करिब {date} ({bs} वि.सं.) मा।",
  "NEA bills this meter on day {day} of each Nepali month.": "NEA ले यो मिटरको बिल हरेक नेपाली महिनाको {day} गते निकाल्छ।",
  "Next bill": "अर्को बिल",
  "No bills yet. Fetch them directly from NEA.": "अहिलेसम्म बिल छैन। NEA बाट सिधै ल्याउनुहोस्।",
  "You can fetch it again later.": "पछि फेरि बिल ल्याउन सकिन्छ।",
  "Fetch bills": "बिल ल्याउनुहोस्",
  "Fetch NEA bills": "NEA बिल ल्याउनुहोस्",
  "NEA bills fetched": "NEA बिल ल्याइयो",
  "Add the NEA office, SC number and consumer ID once, then fetch bills directly from NEA.": "NEA कार्यालय, SC नम्बर र उपभोक्ता आईडी एकपटक राख्नुहोस्, त्यसपछि NEA बाट सिधै बिल ल्याउनुहोस्।",
  "For {station}. Bills are fetched using the saved NEA meter details.": "{station} का लागि। सुरक्षित NEA मिटर विवरण प्रयोग गरेर बिल ल्याइन्छ।",
  "Choose a range of up to three years. Existing bills are refreshed without creating duplicates.": "तीन वर्षसम्मको अवधि छान्नुहोस्। पहिलेकै बिल दोहोरिन नदिई अद्यावधिक गरिन्छ।",
  "Choose a valid date range of up to three years.": "तीन वर्षसम्मको मान्य मिति अवधि छान्नुहोस्।",
  "Fetching bills from NEA…": "NEA बाट बिल ल्याउँदै…",
  "Added {added}, refreshed {updated}, kept {kept} existing bills.": "{added} थपियो, {updated} अद्यावधिक भयो, पहिलेकै {kept} बिल राखियो।",
  "NEA returned no bills for this date range.": "NEA मा यो अवधिको कुनै बिल भेटिएन।",
  "The {month} bill should be out (NEA bills this meter on day {day} of each Nepali month). Fetch it directly from NEA.": "{month} को बिल आइसकेको हुनुपर्छ (NEA ले यो मिटरको बिल प्रत्येक नेपाली महिनाको {day} गते निकाल्छ)। NEA बाट सिधै ल्याउनुहोस्।",
  "Personal wallet": "व्यक्तिगत वालेट",
  "Your own charging credit": "तपाईंको आफ्नै चार्जिङ क्रेडिट",
  "Your signed-in account’s charging credit. Each card uses its linked wallet.": "तपाईंको लगइन खाताको चार्जिङ क्रेडिट। प्रत्येक कार्डले त्यससँग जोडिएको वालेट प्रयोग गर्छ।",
  "Wallet balances": "वालेट मौज्दात",
  "No wallets yet": "अहिलेसम्म वालेट छैन",
  "Contact an operator to add credit to your account.": "खातामा क्रेडिट थप्न सञ्चालकलाई सम्पर्क गर्नुहोस्।",
  "Saadhan wallet": "साधन वालेट",
  "Operator wallet": "सञ्चालक वालेट",
  "Available credit": "उपलब्ध क्रेडिट",
  "Negative balance": "ऋणात्मक मौज्दात",
  "No credit": "क्रेडिट छैन",
  "Recent credit adjustments": "हालैका क्रेडिट समायोजन",
  "No credit adjustments yet": "अहिलेसम्म क्रेडिट समायोजन छैन",
  // Station expenses
  'Approved': 'स्वीकृत',
  'Rejected': 'अस्वीकृत',
  'Awaiting approval': 'स्वीकृतिको पर्खाइमा',
  '{n} expenses approved': '{n} खर्च स्वीकृत भए',
  'Select all': 'सबै छान्नुहोस्',
  'Select': 'छान्नुहोस्',
  'Date': 'मिति',
  'What for': 'केका लागि',
  'Entered by': 'प्रविष्ट गर्ने',
  'Station expenses': 'स्टेसनको खर्च',
  'What each station spends: drinking water, tanker, tiffin, repairs… Staff enter it; managers and you approve it.': 'हरेक स्टेसनको खर्च: पिउने पानी, ट्याङ्कर, खाजा, मर्मत… कर्मचारीले प्रविष्ट गर्छन्; व्यवस्थापक र तपाईं स्वीकृत गर्नुहुन्छ।',
  'Categories': 'शीर्षकहरू',
  'Add expense': 'खर्च थप्नुहोस्',
  'All categories': 'सबै शीर्षक',
  'Approve {n}': '{n} स्वीकृत गर्नुहोस्',
  'No expenses in this period': 'यस अवधिमा कुनै खर्च छैन',
  'Expense approved': 'खर्च स्वीकृत भयो',
  'Fix and send again': 'सच्याएर फेरि पठाउनुहोस्',
  'Reject': 'अस्वीकृत गर्नुहोस्',
  'Approve': 'स्वीकृत गर्नुहोस्',
  'Paid by': 'भुक्तानी माध्यम',
  'Approved by': 'स्वीकृत गर्ने',
  'Rejected by': 'अस्वीकृत गर्ने',
  'Your own expenses are approved by the station owner.': 'तपाईंको आफ्नै खर्च स्टेसनका मालिकले स्वीकृत गर्नुहुन्छ।',
  'Approved expenses can\'t be changed. Record a correction as a new expense.': 'स्वीकृत खर्च परिवर्तन गर्न मिल्दैन। सच्याउन नयाँ खर्च थप्नुहोस्।',
  'Receipt': 'बिल',
  'The receipt could not be loaded.': 'बिल खोल्न सकिएन।',
  'Expense rejected': 'खर्च अस्वीकृत भयो',
  'Delete expense': 'खर्च मेटाउनुहोस्',
  'This expense will be removed.': 'यो खर्च हटाइनेछ।',
  'Expense deleted': 'खर्च मेटाइयो',
  'Why is it rejected?': 'किन अस्वीकृत गरियो?',
  'The person who entered it will see this, and can fix it and send it again.': 'प्रविष्ट गर्ने व्यक्तिले यो देख्नुहुनेछ, र सच्याएर फेरि पठाउन सक्नुहुन्छ।',
  'Choose what it was for': 'केका लागि हो छान्नुहोस्',
  'Enter an amount above 0': '० भन्दा बढी रकम लेख्नुहोस्',
  'The date can\'t be in the future': 'मिति भविष्यको हुन सक्दैन',
  'Saved. It now waits for approval.': 'सुरक्षित भयो। अब स्वीकृतिको पर्खाइमा छ।',
  'Edit expense': 'खर्च सम्पादन',
  'Choose…': 'छान्नुहोस्…',
  'Amount (Rs)': 'रकम (रु)',
  'Receipt photo': 'बिलको फोटो',
  'Optional. jpg, png or webp, up to 5 MB.': 'ऐच्छिक। jpg, png वा webp, ५ MB सम्म।',
  'Attached': 'संलग्न',
  'What was bought, and from whom': 'के किनियो, कसबाट',
  'Category added': 'शीर्षक थपियो',
  'Expense categories': 'खर्चका शीर्षकहरू',
  'Hidden categories are not offered any more, but past expenses keep them.': 'लुकाइएका शीर्षक अब छनोटमा आउँदैनन्, तर पुराना खर्चमा रहिरहन्छन्।',
  'Done': 'सकियो',
  'New category': 'नयाँ शीर्षक',
  'Shown': 'देखाइएको',
  'Daily report': 'दैनिक प्रतिवेदन',
  'Vehicles served, energy and revenue next to what the station spent, and what is left.': 'सेवा पाएका सवारी, ऊर्जा र आम्दानी, स्टेसनको खर्च र बाँकी रकमसँगै।',
  'Spreadsheet for the accountant (CSV)': 'लेखापालका लागि स्प्रेडसिट (CSV)',
  'PDF for management': 'व्यवस्थापनका लागि PDF',
  'Net': 'खुद',
  'Revenue minus approved expenses': 'आम्दानी घटाउ स्वीकृत खर्च',
  'Vehicles served': 'सेवा पाएका सवारी',
  'Approved expenses': 'स्वीकृत खर्च',
  '{n} awaiting approval': '{n} स्वीकृतिको पर्खाइमा',
  'Spent on': 'खर्चका शीर्षक',
  'No approved expenses.': 'स्वीकृत खर्च छैन।',
  'By day': 'दिनअनुसार',
  'Vehicles': 'सवारी',
  'Expenses': 'खर्च',
  'Approved and awaiting approval; rejected ones are left out.': 'स्वीकृत र स्वीकृतिको पर्खाइमा रहेका; अस्वीकृत समावेश छैनन्।',
  'Station expense ledger': 'स्टेसन खर्च खाता',
  'Each day\'s revenue and approved spending by category, then every expense with who entered and approved it.': 'हरेक दिनको आम्दानी र शीर्षकअनुसार स्वीकृत खर्च, अनि हरेक खर्च, कसले प्रविष्ट र स्वीकृत गर्‍यो सहित।',
  'Drinking water': 'पिउने पानी',
  'Water tanker': 'पानी ट्याङ्कर',
  'Tiffin and food': 'खाजा र खाना',
  'Communication': 'सञ्चार',
  'Stationery': 'स्टेसनरी',
  'Charger maintenance': 'चार्जर मर्मत',
  'Labour': 'ज्याला',
  'Cleaning': 'सरसफाइ',
  'Transport': 'यातायात',
  'Cash': 'नगद',
  'Bank': 'बैंक',
  'eSewa': 'इसेवा',
  'Khalti': 'खल्ती',
  // Electricity (NEA bills, time-of-day usage)
  "NEA energy cost": "NEA ऊर्जा लागत",
  "Upload a bill to learn the rates": "दर थाहा पाउन बिल अपलोड गर्नुहोस्",
  "Before VAT, without demand": "भ्याट अघि, डिमान्ड बाहेक",
  "Margin on energy": "ऊर्जामा नाफा",
  "Charging by time of day": "समय अनुसार चार्जिङ",
  "Energy per day in each NEA slot, Nepal time.": "NEA को हरेक समय-खण्डमा दैनिक ऊर्जा, नेपाल समय।",
  "Each slot: what you sell and what it costs": "हरेक समय-खण्ड: कति बेच्नुभयो र कति लागत लाग्यो",
  "NEA tariff category: {category}": "NEA महसुल वर्ग: {category}",
  "Upload this station’s NEA bill to see its electricity cost.": "बिजुली लागत हेर्न यो स्टेसनको NEA बिल अपलोड गर्नुहोस्।",
  "NEA bill against your chargers": "NEA बिल र तपाईंका चार्जरको तुलना",
  "What NEA billed in each slot against what the chargers delivered over the same reading period. The difference is the station’s own use (lights, cooling) and losses.": "एउटै रिडिङ अवधिमा हरेक समय-खण्डमा NEA ले बिल गरेको र चार्जरले दिएको ऊर्जाको तुलना। फरक भनेको स्टेसनको आफ्नै खपत (बत्ती, कुलिङ) र नोक्सानी हो।",
  "Slot": "समय-खण्ड",
  "Share": "हिस्सा",
  "NEA rate": "NEA दर",
  "{rate}/kWh": "{rate}/kWh",
  "NEA cost": "NEA लागत",
  "{share} of your charging is at peak time ({hours}), when NEA charges the most.": "तपाईंको चार्जिङको {share} पिक समयमा ({hours}) हुन्छ, जुनबेला NEA ले सबैभन्दा महँगो लिन्छ।",
  "Moving a tenth of that to normal hours would save about {amount} over this period (with VAT).": "त्यसको दशांश सामान्य समयमा सार्दा यो अवधिमा करिब {amount} बचत हुन्छ (भ्याटसहित)।",
  "Only {share} is in the cheapest, off-peak slot ({hours}).": "सबैभन्दा सस्तो अफ-पिक समयमा ({hours}) जम्मा {share} मात्र छ।",
  "A tenth of normal-hour charging moved to off-peak would save about {amount}.": "सामान्य समयको चार्जिङको दशांश अफ-पिकमा सार्दा करिब {amount} बचत हुन्छ।",
  "What this means": "यसको अर्थ",
  "Set time-of-day prices": "समय अनुसार मूल्य राख्नुहोस्",
  "A dearer peak-time price and a cheaper off-peak price in a time-of-day pricing plan move drivers to the hours that cost you less.": "समय अनुसारको मूल्य योजनामा पिक समयमा महँगो र अफ-पिकमा सस्तो मूल्य राख्दा चालकहरू तपाईंलाई कम लागत पर्ने समयमा आउँछन्।",
  "When drivers charge": "चालकहरू कहिले चार्ज गर्छन्",
  "Energy by weekday and hour. The strip on top shows each hour’s NEA slot.": "बार र घण्टा अनुसार ऊर्जा। माथिको पट्टीले हरेक घण्टाको NEA समय-खण्ड देखाउँछ।",
  "{n} charges started": "{n} चार्ज सुरु भए",
  "Highest load": "सबैभन्दा बढी लोड",
  "The station’s average power over each {n} minutes, as NEA’s demand meter measures it.": "हरेक {n} मिनेटमा स्टेसनको औसत पावर, NEA को डिमान्ड मिटरले नापेजस्तै।",
  "Last bill: {kva} kVA": "पछिल्लो बिल: {kva} kVA",
  "NEA bills this connection {rate} a month for each kVA of its highest load, so a few minutes with every charger busy sets the charge for the whole month. Staggering charges, or limiting station power, lowers it.": "NEA ले यो जडानको सबैभन्दा बढी लोडको हरेक kVA मा महिनाको {rate} लिन्छ, त्यसैले सबै चार्जर चलेका केही मिनेटले नै पूरा महिनाको शुल्क तय गर्छ। चार्जिङ फरक-फरक समयमा गराउँदा वा स्टेसनको पावर सीमित गर्दा यो घट्छ।",
  "This connection is not billed for demand.": "यो जडानमा डिमान्ड शुल्क लाग्दैन।",
  "No charging in this period": "यो अवधिमा चार्जिङ भएन",
  "Next NEA bill": "अर्को NEA बिल",
  "Estimated from your chargers, {from} to {to}.": "{from} देखि {to} सम्म, तपाईंका चार्जरबाट अनुमान।",
  "No estimate yet": "अहिलेसम्म अनुमान छैन",
  "Upload this station’s latest NEA bill. The next one is then estimated from what the chargers deliver.": "यो स्टेसनको पछिल्लो NEA बिल अपलोड गर्नुहोस्। त्यसपछि अर्को बिल चार्जरले दिएको ऊर्जाबाट अनुमान गरिन्छ।",
  "Projected, with VAT": "अनुमानित, भ्याटसहित",
  "So far: {amount} after {days} of {total} days": "अहिलेसम्म: {total} मध्ये {days} दिनमा {amount}",
  "Demand": "डिमान्ड",
  "Scaled up to match the last bill, where {share} of the electricity was the station’s own use and losses.": "पछिल्लो बिलसँग मिलाउन बढाइएको, जहाँ बिजुलीको {share} स्टेसनको आफ्नै खपत र नोक्सानी थियो।",
  "Scaled up to match the last bill, where the chargers recorded {share} less than NEA billed. That is more than own use and losses usually explain: check that every charger on this meter is on Saadhan.": "पछिल्लो बिलसँग मिलाउन बढाइएको, जहाँ चार्जरले NEA ले बिल गरेभन्दा {share} कम रेकर्ड गरे। यो आफ्नै खपत र नोक्सानीले सामान्यतया हुनेभन्दा बढी हो: यो मिटरका सबै चार्जर Saadhan मा छन् कि जाँच गर्नुहोस्।",
  "{n} newer NEA bills aren’t uploaded yet. Upload them to keep this estimate and the comparison accurate.": "{n} वटा नयाँ NEA बिल अझै अपलोड भएका छैनन्। यो अनुमान र तुलना सही राख्न तिनलाई अपलोड गर्नुहोस्।",
  "Some rates are not known yet, so this is incomplete.": "केही दर अझै थाहा छैन, त्यसैले यो अपूर्ण छ।",
  "No bills yet.": "अहिलेसम्म बिल छैन।",
  "chargers {kwh}": "चार्जर {kwh}",
  "NEA / chargers": "NEA / चार्जर",
  "Meters read on different days": "मिटर फरक दिनमा पढिएका",
  "Own use & losses": "आफ्नै खपत र नोक्सानी",
  "Peak load": "उच्च लोड",
  "billed {kva} kVA": "बिल {kva} kVA",
  "NEA meters": "NEA मिटरहरू",
  "Added from the first bill uploaded for each meter, and matched to later bills by SC number.": "हरेक मिटरको पहिलो अपलोड गरिएको बिलबाट थपिन्छ, र पछिका बिल SC नम्बरले मिलाइन्छ।",
  "Upload bills": "बिल अपलोड गर्नुहोस्",
  "No NEA meter yet": "अहिलेसम्म NEA मिटर छैन",
  "Upload the bill PDF from NEA or the NEA app. Several months at once is fine: the meter is added from the first one.": "NEA वा NEA एपबाट बिलको PDF अपलोड गर्नुहोस्। एकैपटक धेरै महिनाका बिल पनि हुन्छ: मिटर पहिलो बिलबाट थपिन्छ।",
  "Newest month first. Units per NEA time-of-day slot; amounts with VAT.": "नयाँ महिना पहिले। NEA समय-खण्ड अनुसार युनिट; रकम भ्याटसहित।",
  "Meter and its bills deleted": "मिटर र यसका बिल मेटाइए",
  "Tariff": "महसुल",
  "Demand charged": "डिमान्ड शुल्क लाग्छ",
  "No demand charge": "डिमान्ड शुल्क लाग्दैन",
  "Delete meter": "मिटर मेटाउनुहोस्",
  "Delete meter {sc}?": "मिटर {sc} मेटाउने?",
  "Its bills are deleted too. Upload a bill again to add it back.": "यसका बिल पनि मेटिन्छन्। फेरि थप्न बिल अपलोड गर्नुहोस्।",
  "Meter {sc}": "मिटर {sc}",
  "Your own name for it, for example “Main transformer”.": "आफ्नै नाम, जस्तै “मुख्य ट्रान्सफर्मर”।",
  "The station this meter feeds. Its bills follow it.": "यो मिटरले बिजुली दिने स्टेसन। यसका बिल पनि सँगै जान्छन्।",
  "Peak / normal / off-peak": "पिक / सामान्य / अफ-पिक",
  "Paid {date}": "{date} मा तिरियो",
  "{pct}% off until {date}": "{date} सम्म {pct}% छुट",
  "Penalty since {date}": "{date} देखि जरिवाना",
  "Due {date}": "{date} सम्म तिर्नुपर्ने",
  "Unpaid": "नतिरिएको",
  "Mark unpaid": "नतिरिएको चिन्ह लगाउनुहोस्",
  "Bill of {period}": "{period} को बिल",
  "Demand charge": "डिमान्ड शुल्क",
  "Before VAT": "भ्याट अघि",
  "To pay": "तिर्नुपर्ने",
  "Bill number": "बिल नम्बर",
  "Rebate and penalty by payment date": "भुक्तानी मिति अनुसार छुट र जरिवाना",
  "After {date}": "{date} पछि",
  "By {date}": "{date} सम्म",
  "Upload at most {n} bills at a time.": "एकपटकमा बढीमा {n} बिल अपलोड गर्नुहोस्।",
  "{n} of {total} bills saved": "{total} मध्ये {n} बिल सुरक्षित भए",
  "Upload NEA bills": "NEA बिल अपलोड गर्नुहोस्",
  "The bill PDFs from NEA or the NEA app, one per month. Only what is read from them is kept, not the files.": "NEA वा NEA एपबाट बिलका PDF, महिनाको एक। फाइल राखिँदैन, त्यसबाट पढिएको विवरण मात्र राखिन्छ।",
  "Save {n} bills": "{n} बिल सुरक्षित गर्नुहोस्",
  "Bill PDFs": "बिलका PDF",
  "{n} files chosen": "{n} फाइल छानिए",
  "Choose bill PDFs": "बिलका PDF छान्नुहोस्",
  "Reading the bills…": "बिल पढ्दै…",
  "Choose other files": "अरू फाइल छान्नुहोस्",
  "Or drop them here": "वा यहाँ छोड्नुहोस्",
  "Can’t read": "पढ्न सकिएन",
  "Another station’s meter": "अर्को स्टेसनको मिटर",
  "Already saved": "पहिले नै सुरक्षित",
  "New meter": "नयाँ मिटर",
  "Matched": "मिल्यो",
  "Station for new meters": "नयाँ मिटरको स्टेसन",
  "Bills for a meter seen for the first time add it to this station.": "पहिलोपटक देखिएको मिटरको बिलले मिटरलाई यो स्टेसनमा थप्छ।",
  "{n} of these months are already saved.": "यीमध्ये {n} महिनाका बिल पहिले नै सुरक्षित छन्।",
  "Replace them with these bills": "तिनलाई यी बिलले बदल्नुहोस्",
  "Electricity": "बिजुली",
  "When your stations charge in NEA’s peak, normal and off-peak hours, what that earns and costs, and your NEA bills.": "तपाईंका स्टेसनमा NEA को पिक, सामान्य र अफ-पिक समयमा कति चार्जिङ हुन्छ, त्यसबाट कति आम्दानी र लागत हुन्छ, र तपाईंका NEA बिल।",
  "Usage & cost": "खपत र लागत",
  "Bills & meters": "बिल र मिटर",
  "Showing the last {n} days of the range.": "अवधिको पछिल्लो {n} दिन देखाइँदै।",
  "NEA tariff": "NEA महसुल",
  "Time-of-day slots, seasons and rates used to cost every station’s charging. Rates are learned from uploaded bills.": "हरेक स्टेसनको चार्जिङको लागत निकाल्न प्रयोग हुने समय-खण्ड, मौसम र दर। दर अपलोड गरिएका बिलबाट लिइन्छ।",
  "NEA tariff settings saved": "NEA महसुल सेटिङ सुरक्षित भयो",
  "Slots and seasons": "समय-खण्ड र मौसम",
  "Nepal time. The windows must cover the whole day once. Changing seasons moves stored bills to their new season.": "नेपाल समय। समय-खण्डले दिनभरि एकपटक समेट्नुपर्छ। मौसम बदल्दा सुरक्षित बिल नयाँ मौसममा सर्छन्।",
  "Time windows": "समय-खण्डहरू",
  "Remove window": "समय-खण्ड हटाउनुहोस्",
  "Add window": "समय-खण्ड थप्नुहोस्",
  "Seasons": "मौसमहरू",
  "Season name": "मौसमको नाम",
  "Add season": "मौसम थप्नुहोस्",
  "Season of {month}": "{month} को मौसम",
  "Rate saved": "दर सुरक्षित भयो",
  "Rate removed": "दर हटाइयो",
  "Rates": "दरहरू",
  "Rs per kWh (per kVA for demand), before VAT. “From a bill” rates follow the newest bill in that category and season.": "प्रति kWh रुपैयाँ (डिमान्डको प्रति kVA), भ्याट अघि। “बिलबाट” भएका दर त्यो वर्ग र मौसमको सबैभन्दा नयाँ बिल अनुसार हुन्छन्।",
  "No rates yet. They appear when the first NEA bill is uploaded.": "अहिलेसम्म दर छैन। पहिलो NEA बिल अपलोड भएपछि देखिन्छन्।",
  "Tariff category": "महसुल वर्ग",
  "Season": "मौसम",
  "Source": "स्रोत",
  "Set by hand": "हातैले राखिएको",
  "From a bill": "बिलबाट",
  "Go back to the bill rate": "बिलको दरमा फर्कनुहोस्",
  "Remove rate": "दर हटाउनुहोस्",
  "Set a rate by hand": "हातैले दर राख्नुहोस्",
  "Rate (Rs)": "दर (रू.)",
  "Save rate": "दर सुरक्षित गर्नुहोस्",
  "Peak (T1)": "पिक (T1)",
  "Normal (T2)": "सामान्य (T2)",
  "Off-peak (T3)": "अफ-पिक (T3)",
  "Baisakh": "वैशाख",
  "Jestha": "जेठ",
  "Asar": "असार",
  "Shrawan": "साउन",
  "Bhadra": "भदौ",
  "Asoj": "असोज",
  "Kartik": "कात्तिक",
  "Mangsir": "मंसिर",
  "Poush": "पुस",
  "Magh": "माघ",
  "Falgun": "फागुन",
  "Chaitra": "चैत",
  "Demand (per kVA)": "डिमान्ड (प्रति kVA)",
  // Bill payments, daily report anomalies, margin periods
  "A specific day…": "कुनै एक दिन…",
  "Day": "दिन",
  "{kwh} actual, with anomalies": "असामान्यतासहित वास्तविक {kwh}",
  "{kwh} left a charger between two sessions, with no session open, so nobody paid for it: {share} of the {actual} the chargers actually gave out.": "दुई सत्रबीच, कुनै सत्र खुला नहुँदा चार्जरबाट {kwh} निस्कियो, त्यसैले कसैले तिरेन: चार्जरले वास्तवमा दिएको {actual} को {share}।",
  "Between transactions": "कारोबारहरूबीच",
  "Session #{id} not found": "सत्र #{id} भेटिएन",
  "Could not open session #{id}": "सत्र #{id} खोल्न सकिएन",
  "Rebate {p}%": "{p}% छुट",
  "Fine {p}%": "{p}% जरिवाना",
  "On time (0%)": "समयमै (0%)",
  "Bill marked paid": "बिल तिरिएको चिन्ह लगाइयो",
  "Bill of {period} paid": "{period} को बिल तिरियो",
  "NEA’s rebate or fine applies to the bill before VAT; VAT is paid as it is.": "NEA को छुट वा जरिवाना भ्याट अघिको रकममा लाग्छ; भ्याट जस्ताको तस्तै तिरिन्छ।",
  "Paid on": "तिरेको मिति",
  "Amount paid": "तिरेको रकम",
  "Paid by {date}": "{date} सम्म तिर्दा",
  "Paid after {date}": "{date} पछि तिर्दा",
  "Another amount": "अर्कै रकम",
  "Amount paid (Rs)": "तिरेको रकम (रू.)",
  "Paid": "तिरियो",
  "Last 2 months": "पछिल्लो २ महिना",
  "Margin %": "नाफा %",
  "Billing cycle": "बिलिङ चक्र",
  "NEA billing cycle": "NEA बिलिङ चक्र",
  "Dates (choose a period)": "मिति (अवधि छान्नुहोस्)",
  "{month} bill: {from} → {to}": "{month} को बिल: {from} → {to}",
  "Current cycle, since {from}": "चालु चक्र, {from} देखि",
  "From {from} to {to}, Nepal time.": "{from} देखि {to} सम्म, नेपाल समय।",
  "From {from} until now, Nepal time.": "{from} देखि अहिलेसम्म, नेपाल समय।",
  "A bill here was uploaded before its time was read, so whole days are used. Upload it again with Replace for the exact time.": "यहाँको एउटा बिल यसको समय पढ्नुअघि अपलोड भएको थियो, त्यसैले पूरा दिन गनिएको छ। ठ्याक्कै समयका लागि यसलाई फेरि Replace गरेर अपलोड गर्नुहोस्।",

  // Charger QR stickers
  'QR code': 'QR कोड',
  'QR stickers': 'QR स्टिकरहरू',
  'QR stickers ({n} connectors)': 'QR स्टिकरहरू ({n} कनेक्टर)',
  'QR stickers for {id} ({n} connectors)': '{id} का QR स्टिकरहरू ({n} कनेक्टर)',
  'QR sticker for {id}': '{id} को QR स्टिकर',
  'One sticker per connector. Print each one and stick it next to its connector. Drivers scan it with their phone camera (opens in the browser) or inside the Saadhan Charge app and start charging on that connector.': 'हरेक कनेक्टरको एउटा स्टिकर। प्रत्येक छापेर सम्बन्धित कनेक्टरको छेउमा टाँस्नुहोस्। चालकहरूले फोनको क्यामेराले (ब्राउजरमा खुल्छ) वा साधन चार्ज एप भित्रबाट स्क्यान गरेर त्यही कनेक्टरमा चार्जिङ सुरु गर्छन्।',
  'No connectors yet, so no sticker: {ids}': 'अहिलेसम्म कनेक्टर छैन, त्यसैले स्टिकर छैन: {ids}',
  'Print': 'प्रिन्ट',
  'Print all': 'सबै प्रिन्ट गर्नुहोस्',
  'Copy link': 'लिङ्क कपी गर्नुहोस्',
  'Link copied': 'लिङ्क कपी भयो',
  'Could not copy the link': 'लिङ्क कपी गर्न सकिएन',
  'Allow pop-ups for this site to print, or download the images instead.': 'प्रिन्ट गर्न यो साइटलाई पप-अप अनुमति दिनुहोस्, वा तस्बिरहरू डाउनलोड गर्नुहोस्।',
  'Could not draw the sticker. Try again.': 'स्टिकर बनाउन सकिएन। फेरि प्रयास गर्नुहोस्।',
  'Preparing the sticker…': 'स्टिकर तयार हुँदैछ…',
  // Online top-ups (superadmin)
  "This page lists drivers' online top-ups once the server has them (aarambhait/ocpp#163). Until then drivers top up at the counter as before.": 'सर्भरमा अनलाइन रिचार्ज आएपछि (aarambhait/ocpp#163) यो पेजले चालकहरूको अनलाइन रिचार्ज देखाउँछ। त्यतिन्जेल चालकहरूले पहिलेझैं काउन्टरमा रिचार्ज गर्छन्।',
  "Credited": "जम्मा भयो",
  "Amount mismatch": "रकम मिलेन",
  "All statuses": "सबै स्थिति",
  "Needs attention": "ध्यान चाहिने",
  "No online top-ups in this period": "यस अवधिमा कुनै अनलाइन रिचार्ज छैन",
  "Service charge": "सेवा शुल्क",
  "Paid with": "भुक्तानी माध्यम",
  "Last checked": "अन्तिम जाँच",
  "Re-check": "फेरि जाँच्नुहोस्",
  "Re-check {ref} with the gateway": "{ref} गेटवेसँग फेरि जाँच्नुहोस्",
  "Gateway {ref}": "गेटवे {ref}",
  "Gateway says {status}": "गेटवे अनुसार {status}",
  "{ago} · {n} checks": "{ago} · {n} पटक जाँच",
  "{ref}: {status}": "{ref}: {status}",
  "{n} top-ups · drivers paid {charge} in charges": "{n} रिचार्ज · चालकले शुल्कमा {charge} तिरे",
  "{expired} expired · {mismatch} amount mismatch": "{expired} म्याद सकिएको · {mismatch} रकम नमिलेको",
  "Drivers topping up their Saadhan wallet through Nepal Payment Solutions. A top-up is credited only once the gateway confirms the same amount.": "नेपाल पेमेन्ट सोलुसन्समार्फत चालकहरूले साधन वालेट रिचार्ज गरेको। गेटवेले उही रकम पुष्टि गरेपछि मात्र रिचार्ज जम्मा हुन्छ।",
  "Expired: never confirmed within two days. Amount mismatch: the gateway confirmed a different amount, so nothing was credited. Re-check first; if the driver's bank was charged and it still isn't credited, add the credit by hand from Users.": "म्याद सकिएको: दुई दिनभित्र पुष्टि भएन। रकम मिलेन: गेटवेले फरक रकम पुष्टि गर्‍यो, त्यसैले केही जम्मा भएन। पहिले फेरि जाँच्नुहोस्; चालकको बैंकबाट पैसा काटिएर पनि जम्मा भएको छैन भने प्रयोगकर्ताहरू पेजबाट हातैले क्रेडिट थप्नुहोस्।",
  "Credit": "क्रेडिट",
  "Other writes": "अन्य परिवर्तनहरू",
  "History": "इतिहास",
  "All actions": "सबै कार्यहरू",
  "System only": "प्रणाली मात्र",
  "Device": "उपकरण",
  "IP address": "आईपी ठेगाना",
  "Request": "अनुरोध",
  "Action": "कार्य",
  "Summary": "सारांश",
  "Item": "वस्तु",
  "From where": "कहाँबाट",
  "Every change on the platform. Pick an operator to see only theirs.": "प्लेटफर्मका सबै परिवर्तनहरू। सञ्चालक छान्नुभयो भने उनीहरूको मात्र देखिन्छ।",
  "No visible changes": "देखिने कुनै परिवर्तन छैन",
  "Plan created": "योजना बनाइयो",
  "Plan updated": "योजना अद्यावधिक भयो",
  "Plan assigned": "योजना तोकियो",
  "Credit deducted": "क्रेडिट घटाइयो",
  "Card created": "कार्ड बनाइयो",
  "Card blocked": "कार्ड रोकियो",
  "Card unblocked": "कार्ड खोलियो",
  "Card deleted": "कार्ड मेटियो",
  "Charger reset": "चार्जर रिसेट",
  "Connector unlocked": "कनेक्टर अनलक भयो",
  "Remote start": "रिमोट सुरु",
  "Remote stop": "रिमोट बन्द",
  "Connector status changed": "कनेक्टरको स्थिति बदलियो",
  "Charger created": "चार्जर बनाइयो",
  "Charger updated": "चार्जर अद्यावधिक भयो",
  "Station updated": "स्टेसन अद्यावधिक भयो",
  "Session status overridden": "सत्रको स्थिति सच्याइयो",
  "Staff access changed": "कर्मचारी पहुँच बदलियो",
  "User updated": "प्रयोगकर्ता अद्यावधिक भयो",
  "User activated": "प्रयोगकर्ता सक्रिय भयो",
  "User deactivated": "प्रयोगकर्ता निष्क्रिय भयो",
  "User deleted": "प्रयोगकर्ता मेटियो",
  "Operator created": "सञ्चालक बनाइयो",
  "Operator deleted": "सञ्चालक मेटियो",
  "Settings created": "सेटिङ बनाइयो",
  "Settings updated": "सेटिङ अद्यावधिक भयो",
  "Other write: POST": "अन्य परिवर्तन: POST",
  "Other write: PUT": "अन्य परिवर्तन: PUT",
  "Other write: PATCH": "अन्य परिवर्तन: PATCH",
  "Other write: DELETE": "अन्य परिवर्तन: DELETE",
  "All connectors": "सबै कनेक्टर",
  "Earlier session": "अघिल्लो सत्र",
  "Download started. The export includes every connector.": "डाउनलोड सुरु भयो। निर्यातमा सबै कनेक्टर समावेश छन्।",
  "Pick an operator first": "पहिले सञ्चालक छान्नुहोस्",
}
